webpackJsonp([1],Array(56).concat([
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);



/* harmony default export */ __webpack_exports__["a"] = (new (function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, _class);

        this.listeners = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a();
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(_class, [{
        key: 'addListener',
        value: function addListener(label, callback, vm) {
            if (typeof callback == 'function') {
                this.listeners.has(label) || this.listeners.set(label, []);
                this.listeners.get(label).push({ callback: callback, vm: vm });

                return true;
            }

            return false;
        }
    }, {
        key: 'removeListener',
        value: function removeListener(label, callback, vm) {
            var listeners = this.listeners.get(label),
                index = void 0;

            if (listeners && listeners.length) {
                index = listeners.reduce(function (i, listener, index) {
                    return typeof listener.callback == 'function' && listener.callback === callback && listener.vm == vm ? i = index : i;
                }, -1);

                if (index > -1) {
                    listeners.splice(index, 1);
                    this.listeners.set(label, listeners);
                    return true;
                }
            }
            return false;
        }
    }, {
        key: 'emit',
        value: function emit(label) {
            for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                args[_key - 1] = arguments[_key];
            }

            var listeners = this.listeners.get(label);

            if (listeners && listeners.length) {
                listeners.forEach(function (listener) {
                    var _listener$callback;

                    (_listener$callback = listener.callback).call.apply(_listener$callback, [listener.vm].concat(args));
                });
                return true;
            }
            return false;
        }
    }]);

    return _class;
}())());

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]());

/***/ }),
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(148),
  /* template */
  __webpack_require__(397),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(151),
  /* template */
  __webpack_require__(400),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(152),
  /* template */
  __webpack_require__(404),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(160),
  /* template */
  __webpack_require__(384),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 112 */,
/* 113 */,
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Observer__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Emitter__ = __webpack_require__(56);




/* harmony default export */ __webpack_exports__["a"] = ({
    install: function install(Vue, connection) {

        if (!connection) throw new Error("[Vue-Socket.io] cannot locate connection");

        var observer = new __WEBPACK_IMPORTED_MODULE_1__Observer__["a" /* default */](connection);

        Vue.prototype.$socket = observer.Socket;

        Vue.mixin({
            beforeCreate: function beforeCreate() {
                var _this = this;
                var sockets = this.$options['sockets'];

                if (sockets) {
                    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sockets).forEach(function (key) {
                        __WEBPACK_IMPORTED_MODULE_2__Emitter__["a" /* default */].addListener(key, sockets[key], _this);
                    });
                }
            },
            beforeDestroy: function beforeDestroy() {
                var _this = this;
                var sockets = this.$options['sockets'];

                if (sockets) {
                    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sockets).forEach(function (key) {
                        __WEBPACK_IMPORTED_MODULE_2__Emitter__["a" /* default */].removeListener(key, sockets[key], _this);
                    });
                }
            }
        });
    }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function imgReloadBlank(src) {

    var blankList = [],
        imgs = window.document.body.getElementsByTagName("img"),
        img,
        i,
        srcSegments,
        relativeSrc;

    for (i = imgs.length; i--;) {
        img = imgs[i];
        srcSegments = img.src.split('/');
        relativeSrc = '/' + srcSegments.slice(3).join('/');
        if (relativeSrc === src) {
            img.src = "/userdata/avatar_blank_100.jpg";
            blankList.push(img);
        }
    }

    return blankList;
}

function imgReloadRestore(src, blankList) {
    var i, img;

    for (i = blankList.length; i--;) {
        (img = blankList[i]).src = src;
    }
}

/* harmony default export */ __webpack_exports__["a"] = (function (src) {
    var blankList,
        step = 0,
        iframe = window.document.createElement("iframe"),
        loadCallback = function loadCallback(e) {
        if (!step) {
            step = 2;
            blankList = imgReloadBlank(src);
            iframe.contentWindow.location.reload(true);
        } else if (step === 2) {
            imgReloadRestore(src, blankList);
            if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
        }
    };

    iframe.style.display = "none";
    window.parent.document.body.appendChild(iframe);
    iframe.addEventListener("load", loadCallback, false);
    iframe.addEventListener("error", loadCallback, false);
    iframe.src = src;
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Layouts_ChatLayout__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Layouts_ChatLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Layouts_ChatLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Layouts_HomeLayout__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Layouts_HomeLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Layouts_HomeLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layouts_ProfileLayout__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layouts_ProfileLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Layouts_ProfileLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Layouts_LegalDocumentLayout__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Layouts_LegalDocumentLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Layouts_LegalDocumentLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__LegalDocs_TermsAndConditions__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__LegalDocs_TermsAndConditions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__LegalDocs_TermsAndConditions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__LegalDocs_PrivacyPolicy__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__LegalDocs_PrivacyPolicy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__LegalDocs_PrivacyPolicy__);









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    routes: [{
        path: '/',
        name: 'HomePage',
        component: __WEBPACK_IMPORTED_MODULE_3__Layouts_HomeLayout___default.a
    }, {
        path: '/Chat',
        name: 'ChatLayout',
        component: __WEBPACK_IMPORTED_MODULE_2__Layouts_ChatLayout___default.a
    }, {
        path: '/Profile/:stringUrl',
        name: 'ProfileLayout',
        component: __WEBPACK_IMPORTED_MODULE_4__Layouts_ProfileLayout___default.a
    }, {
        path: '/Doc',
        name: 'LegalDocLayout',
        component: __WEBPACK_IMPORTED_MODULE_5__Layouts_LegalDocumentLayout___default.a,
        children: [{
            path: 'TOC',
            name: 'TermsAndConditions',
            component: __WEBPACK_IMPORTED_MODULE_6__LegalDocs_TermsAndConditions___default.a
        }, {
            path: 'PrivacyPolicy',
            name: 'PrivacyPolicy',
            component: __WEBPACK_IMPORTED_MODULE_7__LegalDocs_PrivacyPolicy___default.a
        }]
    }],
    mode: 'history'
}));

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Common_LoggedUserModel__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ChatRoom_ActiveChatModel__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ChatRoom_chatMessagesModel__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ChatRoom_PublicChatsModel__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ChatRoom_GroupChatsModel__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ChatRoom_FriendChatsModel__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ChatRoom_OnlineUsersModel__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ChatRoom_IgnoredUsersModel__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ChatRoom_ChatroomConfigModel__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Common_TitleBarModel__ = __webpack_require__(181);











/* harmony default export */ __webpack_exports__["a"] = (function (options) {
    var Vuex = options.Vuex;

    return new Vuex.Store({
        state: {},
        mutations: {},
        actions: {},
        getters: {},
        modules: {
            loggedUserModel: __WEBPACK_IMPORTED_MODULE_0__Common_LoggedUserModel__["a" /* default */],
            publicChatsModel: __WEBPACK_IMPORTED_MODULE_3__ChatRoom_PublicChatsModel__["a" /* default */],
            groupChatsModel: __WEBPACK_IMPORTED_MODULE_4__ChatRoom_GroupChatsModel__["a" /* default */],
            friendChatsModel: __WEBPACK_IMPORTED_MODULE_5__ChatRoom_FriendChatsModel__["a" /* default */],
            activeChatModel: __WEBPACK_IMPORTED_MODULE_1__ChatRoom_ActiveChatModel__["a" /* default */],
            chatMessagesModel: __WEBPACK_IMPORTED_MODULE_2__ChatRoom_chatMessagesModel__["a" /* default */],
            onlineUsersModel: __WEBPACK_IMPORTED_MODULE_6__ChatRoom_OnlineUsersModel__["a" /* default */],
            ignoredUsersModel: __WEBPACK_IMPORTED_MODULE_7__ChatRoom_IgnoredUsersModel__["a" /* default */],
            chatroomConfigModel: __WEBPACK_IMPORTED_MODULE_8__ChatRoom_ChatroomConfigModel__["a" /* default */],
            titleBarModel: __WEBPACK_IMPORTED_MODULE_9__Common_TitleBarModel__["a" /* default */]
        }
    });
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Common_LoadingElements_LoadingLarge_vue__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Common_LoadingElements_LoadingLarge_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Common_LoadingElements_LoadingLarge_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Common_LoadingElements_LoadingSmall_vue__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Common_LoadingElements_LoadingSmall_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Common_LoadingElements_LoadingSmall_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Common_LoadingElements_SavingLarge_vue__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Common_LoadingElements_SavingLarge_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Common_LoadingElements_SavingLarge_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Common_MarkdownContent_vue__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Common_MarkdownContent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Common_MarkdownContent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Common_FakeYoutube_vue__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Common_FakeYoutube_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Common_FakeYoutube_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Common_Modal_vue__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Common_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Common_Modal_vue__);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('loader-large', __WEBPACK_IMPORTED_MODULE_1__Common_LoadingElements_LoadingLarge_vue___default.a);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('loader-small', __WEBPACK_IMPORTED_MODULE_2__Common_LoadingElements_LoadingSmall_vue___default.a);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('saver-large', __WEBPACK_IMPORTED_MODULE_3__Common_LoadingElements_SavingLarge_vue___default.a);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('markdown-content', __WEBPACK_IMPORTED_MODULE_4__Common_MarkdownContent_vue___default.a);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('fake-youtube', __WEBPACK_IMPORTED_MODULE_5__Common_FakeYoutube_vue___default.a);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('modal', __WEBPACK_IMPORTED_MODULE_6__Common_Modal_vue___default.a);

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('formatDate', function (datetime) {
    var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sep", "Oct", "Nov", "Dec"],
        outputDate = new Date(datetime),
        hours = outputDate.getHours(),
        ampm = 'am',
        minutes = void 0;

    if (hours > 12) {
        ampm = 'pm';
        hours -= 12;
    }

    if (hours === 0) {
        hours = 12;
    }

    minutes = (outputDate.getMinutes() < 10 ? '0' : '') + outputDate.getMinutes();

    return hours + ':' + minutes + ampm + ', ' + monthNames[outputDate.getMonth()] + " " + outputDate.getDate();
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('formatDateWithoutTime', function (datetime) {
    var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sep", "Oct", "Nov", "Dec"],
        outputDate = new Date(datetime);

    return monthNames[outputDate.getMonth()] + " " + outputDate.getDate() + ", " + outputDate.getFullYear();
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('formatDateWithJustTime', function (datetime) {
    var outputDate = new Date(datetime),
        hours = outputDate.getHours(),
        ampm = 'am',
        minutes = void 0;

    if (hours >= 12) {
        ampm = 'pm';
        hours -= 12;
    }

    if (hours === 0) {
        hours = 12;
    }

    minutes = (outputDate.getMinutes() < 10 ? '0' : '') + outputDate.getMinutes();

    return hours + ':' + minutes + ampm;
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('formatDateCondensed', function (datetime) {
    var outputDate = new Date(datetime),
        hours = outputDate.getHours(),
        ampm = 'am',
        minutes = void 0;

    if (hours >= 12) {
        ampm = 'pm';
        hours -= 12;
    }

    if (hours === 0) {
        hours = 12;
    }

    minutes = (outputDate.getMinutes() < 10 ? '0' : '') + outputDate.getMinutes();

    return outputDate.getMonth() + 1 + '.' + outputDate.getDate() + "." + outputDate.getFullYear() + ' | ' + hours + ':' + minutes + ampm;
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('joinArray', function (input, subArr) {
    var output = void 0;
    var subArrCombined = [];

    if (subArr) {
        input.forEach(function (item) {
            subArrCombined.push(item[subArr]);
        });
        output = subArrCombined.join(', ');
    } else {
        output = input.join(', ');
    }

    return output;
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('markdown', function (content) {
    var markdownTargetBlank = __webpack_require__(183);

    var md = __webpack_require__(249)({
        html: false,
        linkify: true,
        breaks: false,
        typographer: true
    }).use(markdownTargetBlank);

    md.disable(['heading', 'fence', 'blockquote', 'code', 'hr', 'html_block', 'lheading', 'list', 'reference']);

    content = md.render(content);

    return content;
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('capitalizeFirstLetter', function (content) {
    return content.charAt(0).toUpperCase() + content.slice(1);
});

/***/ }),
/* 120 */,
/* 121 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(242)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(143),
  /* template */
  __webpack_require__(385),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app',

    computed: {
        titleBar: function titleBar() {
            var originalTitle = this.$store.state.titleBarModel.originalTitle,
                alert = this.$store.state.titleBarModel.alert,
                divider = this.$store.state.titleBarModel.divider,
                finalTitleBar = '';

            if (alert) {
                finalTitleBar += alert + divider;
            }

            finalTitleBar += originalTitle;

            return finalTitleBar;
        }
    },

    methods: {
        fetchLoginStatus: function fetchLoginStatus() {
            var _this = this;

            setTimeout(function () {
                _this.$store.dispatch('loggedUserModel/fetchLoggedUserInfo', function () {
                    if (!_this.$store.state.loggedUserModel.isLoggedIn && ['ChatLayout'].indexOf(_this.$route.name) > -1) {
                        _this.$router.push('/');
                    }

                    if (_this.$store.state.loggedUserModel.isLoggedIn) {
                        _this.$socket.emit("setUserSocketData", _this.$store.state.loggedUserModel.info);
                    }
                });
            }, 2000);
        },
        setTitleBar: function setTitleBar() {
            document.title = this.titleBar;
        }
    },

    mounted: function mounted() {
        var _this2 = this;

        this.fetchLoginStatus();
        this.setTitleBar();

        document.addEventListener('focus', function () {
            _this2.$store.state.titleBarModel.isVisible = true;
            if (_this2.$store.state.titleBarModel.alert) {
                _this2.$store.state.titleBarModel.alert = undefined;
            }
        }, false);

        document.addEventListener('blur', function () {
            _this2.$store.state.titleBarModel.isVisible = false;
        }, false);

        window.addEventListener('focus', function () {
            _this2.$store.state.titleBarModel.isVisible = true;
            if (_this2.$store.state.titleBarModel.alert) {
                _this2.$store.state.titleBarModel.alert = undefined;
            }
        }, false);

        window.addEventListener('blur', function () {
            _this2.$store.state.titleBarModel.isVisible = false;
        }, false);
    },


    sockets: {
        'onlineUsersUpdate': function onlineUsersUpdate(data) {
            this.$store.commit('onlineUsersModel/setOnlineUsers', data.onlineUsers);
        }
    },

    watch: {
        'titleBar': function titleBar() {
            this.setTitleBar();
        }
    }
});

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_images_loaded__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_images_loaded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_images_loaded__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ThemeSelector_vue__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ThemeSelector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ThemeSelector_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ChatPanel',
  components: {
    'theme-selector': __WEBPACK_IMPORTED_MODULE_3__ThemeSelector_vue___default.a
  },

  data: function data() {
    return {
      newMessage: '',
      fetchingMessages: false,
      showPanelEmoji: false,
      showPanelCommands: false,
      showPanelGiphy: false,
      giphySearch: '',
      giphyResults: [],
      emojiList: [],
      shouldScrollDown: true,
      gamePanelEnabled: false,
      giphySearching: false,
      isUploading: false,
      themeSelectorEnabled: false,
      publicGroupsSelected: false,
      publicGroupList: [],
      joiningPublicGroup: false
    };
  },


  directives: {
    imagesLoaded: __WEBPACK_IMPORTED_MODULE_2_vue_images_loaded___default.a
  },

  computed: {
    isDarkMode: function isDarkMode() {
      return this.$store.state.loggedUserModel.info.darkmode;
    },
    chatId: function chatId() {
      return this.$store.state.activeChatModel.id;
    },
    ownId: function ownId() {
      return this.$store.state.loggedUserModel.isLoggedIn ? this.$store.state.loggedUserModel.info.id : 0;
    },
    ignoredUsers: function ignoredUsers() {
      return this.$store.state.ignoredUsersModel.ignoredUsers;
    },
    userVoteThreshold: function userVoteThreshold() {
      return this.$store.state.loggedUserModel.info.ignoreThreshold;
    },
    chatMessages: function chatMessages() {
      var messages = void 0,
          output = [],
          ignoredUsers = this.ignoredUsers,
          useSwearFilters = this.$store.state.loggedUserModel.info.useSwearFilter;

      if (this.fetchingMessages) {
        return [];
      }

      messages = this.$store.state.chatMessagesModel.chatMessages[this.chatId];

      if (!messages) {
        return [];
      }

      if (useSwearFilters) {
        for (var i = 0; i < messages.length; i++) {
          messages[i].message = messages[i].message.replace(/fuck/ig, '****');
          messages[i].message = messages[i].message.replace(/shit/ig, '****');
          messages[i].message = messages[i].message.replace(/bitch/ig, '*****');
          messages[i].message = messages[i].message.replace(/cunt/ig, '****');
          messages[i].message = messages[i].message.replace(/pussy/ig, '*****');
          messages[i].message = messages[i].message.replace(/dick/ig, '****');
          messages[i].message = messages[i].message.replace(/cock/ig, '****');
          messages[i].message = messages[i].message.replace(/asshole/ig, '*******');
          messages[i].message = messages[i].message.replace(/fag/ig, '***');
          messages[i].message = messages[i].message.replace(/faggot/ig, '******');
          messages[i].message = messages[i].message.replace(/nigger/ig, '******');
          messages[i].message = messages[i].message.replace(/douche/ig, '******');
        }
      }

      for (var _i = 0; _i < messages.length; _i++) {
        var streakCount = 0,
            j = _i,
            groupMessages = [];

        messages[_i].isIgnored = ignoredUsers.indexOf(messages[_i].posterId) >= 0;

        while (j < messages.length - 1 && messages[j].posterId === messages[j + 1].posterId && messages[j].posterId !== 0) {
          streakCount++;
          j++;
        }

        if (streakCount > 0) {
          streakCount++;
          groupMessages = {
            type: 'group',
            messages: []
          };

          for (var k = 0; k < streakCount; k++) {
            groupMessages.messages.push(messages[k + _i]);
          }

          output.push(groupMessages);
          _i += streakCount;
          _i--;
        } else {
          output.push(messages[_i]);
        }
      }

      return output;
    }
  },

  methods: {
    fetchMessages: function fetchMessages() {
      var _this = this;

      if (!this.$store.state.chatMessagesModel.chatMessages[this.chatId]) {
        this.fetchingMessages = true;
        setTimeout(function () {
          _this.$store.dispatch('chatMessagesModel/fetchChatMessages', {
            chatId: _this.chatId,
            callback: function callback() {
              _this.fetchingMessages = false;
            }
          });
        }, 500);
      }
    },
    fetchPublicGroups: function fetchPublicGroups() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/publicGroups').then(function (response) {
        if (!response.data.error) {
          _this2.publicGroupList = response.data;
        }
      });
    },
    joinPublicGroup: function joinPublicGroup(groupId) {
      var _this3 = this;

      this.joiningPublicGroup = true;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/publicGroups/joinGroup', {
        groupId: groupId
      }).then(function (response) {
        if (response.data.errors) {
          return;
        }
        _this3.joiningPublicGroup = false;
        _this3.fetchPublicGroups();
        _this3.$store.dispatch('groupChatsModel/fetchGroupChats');
      }, function (response) {
        _this3.joiningPublicGroup = false;
      });
    },
    updateReadStatus: function updateReadStatus() {
      var _this4 = this;

      setTimeout(function () {
        _this4.$store.dispatch('chatMessagesModel/updateReadStatus', {
          chatId: _this4.chatId
        });
      }, 500);

      if (this.chatId.split('.')[0] === 'private') {
        this.$store.commit('friendChatsModel/clearReadMessages', { chatId: parseInt(this.chatId.split('.')[1], 10) });
      }

      if (this.chatId.split('.')[0] === 'group') {
        this.$store.commit('groupChatsModel/clearReadMessages', { chatId: parseInt(this.chatId.split('.')[1], 10) });
      }

      if (this.chatId.split('.')[0] === 'public') {
        this.$store.commit('publicChatsModel/clearReadMessages', { chatId: parseInt(this.chatId.split('.')[1], 10) });
      }
    },
    fetchEmoji: function fetchEmoji() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/emoji').then(function (response) {
        _this5.emojiList = response.data;
      });
    },
    addEmoji: function addEmoji(emoji) {
      if (this.newMessage.trim() !== '') {
        this.newMessage += ' ';
      }

      this.newMessage += emoji;

      this.$refs.inputChatBox.focus();
    },
    generateAvatarImage: function generateAvatarImage(message) {
      var hasAvatar = message.posterHasAvatar,
          id = message.posterId,
          avatarId = new Date(message.posterAvatarUpdate).getTime();

      if (message.isIgnored || message.voteValue <= this.userVoteThreshold) {
        hasAvatar = false;
      }

      if (hasAvatar) {
        return '/userdata/avatars/' + id + '.jpg?v=' + avatarId;
      } else {
        return '/defaultProfilePic.png';
      }
    },
    submitMessage: function submitMessage() {
      this.showPanelEmoji = false;
      this.showPanelCommands = false;
      this.showPanelGiphy = false;
      this.themeSelectorEnabled = false;
      this.publicGroupsSelected = false;
      this.newMessage = this.newMessage.trim();

      this.$refs.inputChatBox.focus();

      if (this.newMessage === '') {
        return;
      }

      this.$store.dispatch('chatMessagesModel/sendMessage', {
        chatId: this.chatId,
        message: this.newMessage
      });

      this.newMessage = '';
    },
    scrollDownMessages: function scrollDownMessages() {
      var $chatMessages = document.getElementById('chat-messages-list');

      if ($chatMessages && this.shouldScrollDown) {
        $chatMessages.scrollTop = $chatMessages.scrollHeight;
      }
    },
    tagUser: function tagUser(userName) {
      if (this.newMessage.trim() !== '') {
        this.newMessage += ' ';
      }

      this.newMessage += '@' + userName + ': ';

      this.$refs.inputChatBox.focus();
    },
    toggleEmojiPanel: function toggleEmojiPanel() {
      this.showPanelEmoji = !this.showPanelEmoji;
      if (this.showPanelEmoji) {
        this.showPanelCommands = false;
        this.showPanelGiphy = false;
        this.themeSelectorEnabled = false;
        this.publicGroupsSelected = false;
      }
    },
    toggleCommandsPanel: function toggleCommandsPanel() {
      this.showPanelCommands = !this.showPanelCommands;
      if (this.showPanelCommands) {
        this.showPanelEmoji = false;
        this.showPanelGiphy = false;
        this.themeSelectorEnabled = false;
        this.publicGroupsSelected = false;
      }
    },
    toggleGiphyPanel: function toggleGiphyPanel() {
      var _this6 = this;

      this.showPanelGiphy = !this.showPanelGiphy;
      if (this.showPanelGiphy) {
        this.showPanelEmoji = false;
        this.showPanelCommands = false;
        this.themeSelectorEnabled = false;
        this.publicGroupsSelected = false;

        this.$nextTick(function () {
          _this6.$refs.giphyInput.focus();
        });
      }
    },
    toggleGamePanel: function toggleGamePanel() {
      this.gamePanelEnabled = !this.gamePanelEnabled;
    },
    toggleThemeSelector: function toggleThemeSelector() {
      this.themeSelectorEnabled = !this.themeSelectorEnabled;
      if (this.themeSelectorEnabled) {
        this.showPanelEmoji = false;
        this.showPanelCommands = false;
        this.showPanelGiphy = false;
        this.publicGroupsSelected = false;
      }
    },
    togglePublicGroups: function togglePublicGroups() {
      this.publicGroupsSelected = !this.publicGroupsSelected;
      if (this.publicGroupsSelected) {
        this.showPanelEmoji = false;
        this.showPanelCommands = false;
        this.showPanelGiphy = false;
        this.themeSelectorEnabled = false;
      }
    },
    exitThemeSelectMode: function exitThemeSelectMode() {
      this.themeSelectorEnabled = false;
    },
    addGiphyToChat: function addGiphyToChat(giphyId) {
      this.showPanelEmoji = false;
      this.showPanelCommands = false;
      this.showPanelGiphy = false;

      this.$store.dispatch('chatMessagesModel/sendMessage', {
        chatId: this.chatId,
        message: '/giphy ' + giphyId
      });
    },


    findGiphys: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(function () {
      var _this7 = this;

      this.giphySearch = this.giphySearch.trim();

      if (this.giphySearch === '') {
        return;
      }

      this.giphySearching = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://api.giphy.com/v1/gifs/search', {
        params: {
          api_key: '09324ca51eb143778ee350fbc84ae948',
          q: this.giphySearch
        }
      }).then(function (response) {
        _this7.giphySearching = false;
        _this7.giphyResults = response.data.data;
      });
    }, 500),

    ignoreUser: function ignoreUser(ignoredId) {
      var _this8 = this;

      this.$store.dispatch('ignoredUsersModel/toggleIgnoreStatus', {
        ignoredId: ignoredId,
        callback: function callback() {
          _this8.$store.dispatch('ignoredUsersModel/fetchIgnoredUsers', { chatId: _this8.chatId });
        }
      });
    },
    voteUserUp: function voteUserUp(userId) {
      this.sendUserVote(userId, 1);
    },
    voteUserDown: function voteUserDown(userId) {
      this.sendUserVote(userId, -1);
    },
    sendUserVote: function sendUserVote(userId, voteValue) {
      var _this9 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/voteUser', {
        votedId: userId,
        voteValue: voteValue
      }).then(function (response) {
        _this9.$store.dispatch('chatMessagesModel/fetchChatMessages', { chatId: _this9.chatId });
      });
    },
    uploadFile: function uploadFile(e) {
      var _this10 = this;

      var input = e.target,
          file = void 0,
          formData = new FormData(),
          originatingChatId = this.chatId;

      if (input.files.length === 0) {
        return;
      }

      file = input.files[0];

      if (input.files[0].size > 10 * 1024 * 1024) {
        return;
      }

      this.isUploading = true;

      formData.append('uploadedFile', file);
      formData.append('chatId', this.chatId);

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/fileUploader', formData).then(function (response) {
        _this10.isUploading = false;

        if (!response.data.errors && response.data.response === 'success') {
          var filename = response.data.filePath.split('/')[2];
          var message = 'Uploaded a File: [' + filename + '](' + (window.location.origin + escape(response.data.filePath)) + ')';

          _this10.$store.dispatch('chatMessagesModel/sendMessage', {
            chatId: originatingChatId,
            message: message
          });
        }
      });
    }
  },

  mounted: function mounted() {
    var _this11 = this;

    this.fetchMessages();
    this.fetchEmoji();
    this.fetchPublicGroups();

    this.$store.dispatch('videoChatModel/configure', function () {
      _this11.$store.dispatch('videoChatModel/connectToServer');
    });
  },


  sockets: {
    'updateChatMessages': function updateChatMessages(data) {
      var _this12 = this;

      var $chatMessages = document.getElementById('chat-messages-list');

      this.shouldScrollDown = $chatMessages && Math.abs($chatMessages.scrollTop + $chatMessages.offsetHeight - $chatMessages.scrollHeight) < 100;

      this.updateReadStatus();

      data.callback = function () {
        if (!_this12.$store.state.titleBarModel.isVisible && data.chatId.split('.')[0] !== 'public') {
          _this12.$store.state.titleBarModel.alert = _this12.$store.state.titleBarModel.defaultAlert;
        }
      };

      this.$store.dispatch('chatMessagesModel/fetchChatMessages', data);
    }
  },

  watch: {
    'chatId': function chatId() {
      this.fetchMessages();
      this.updateReadStatus();
      this.$refs.inputChatBox.focus();
    },
    'chatMessages': function chatMessages() {
      var _this13 = this;

      this.$nextTick(function () {
        _this13.scrollDownMessages();
      });
    },
    'giphySearch': function giphySearch() {
      this.findGiphys();
    }
  }
});

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ThemeSelector',

  data: function data() {
    return {
      availableThemes: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i']
    };
  },


  computed: {
    isDarkMode: function isDarkMode() {
      return this.$store.state.loggedUserModel.info.darkmode;
    },
    selectedTheme: function selectedTheme() {
      return this.$store.state.loggedUserModel.info.theme;
    }
  },

  methods: {
    selectTheme: function selectTheme(theme) {
      this.$set(this.$store.state.loggedUserModel.info, 'theme', theme);
      this.saveTheme();
    },
    toggleDarkMode: function toggleDarkMode() {
      if (this.isDarkMode) {
        this.$set(this.$store.state.loggedUserModel.info, 'darkmode', false);
      } else {
        this.$set(this.$store.state.loggedUserModel.info, 'darkmode', true);
      }

      this.saveTheme();
    },
    saveTheme: function saveTheme() {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/member/saveTheme', {
        theme: this.selectedTheme,
        isDarkMode: this.isDarkMode
      }).then();
    },
    closePanel: function closePanel() {
      this.$emit('exitThemeSelectMode');
    }
  }
});

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ChatSidePanelWidgets_UserChats_vue__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ChatSidePanelWidgets_UserChats_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ChatSidePanelWidgets_UserChats_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ChatSidePanelWidgets_GroupDetails_vue__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ChatSidePanelWidgets_GroupDetails_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ChatSidePanelWidgets_GroupDetails_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ActiveChatsPanel',
	components: {
		'user-chats': __WEBPACK_IMPORTED_MODULE_0__ChatSidePanelWidgets_UserChats_vue___default.a,
		'group-details': __WEBPACK_IMPORTED_MODULE_1__ChatSidePanelWidgets_GroupDetails_vue___default.a
	},

	computed: {
		activeChatId: function activeChatId() {
			return this.$store.state.activeChatModel.id;
		},
		activeChatType: function activeChatType() {
			return !this.activeChatId ? '' : this.activeChatId.split('.')[0];
		},
		selectedTheme: function selectedTheme() {
			return this.$store.state.loggedUserModel.info.theme;
		},
		isRolledOut: function isRolledOut() {
			return this.$store.state.chatroomConfigModel.fullSidePanelMode;
		}
	}

});

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ChatSidePanelWidgets_LoggedDetails_vue__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ChatSidePanelWidgets_LoggedDetails_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ChatSidePanelWidgets_LoggedDetails_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ChatSidePanelWidgets_OnlineUsers_vue__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ChatSidePanelWidgets_OnlineUsers_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ChatSidePanelWidgets_OnlineUsers_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ChatSidePanelWidgets_UserChats_vue__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ChatSidePanelWidgets_UserChats_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ChatSidePanelWidgets_UserChats_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ChatSidePanelWidgets_GroupDetails_vue__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ChatSidePanelWidgets_GroupDetails_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ChatSidePanelWidgets_GroupDetails_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ChatSidePanel',
    components: {
        'logged-details': __WEBPACK_IMPORTED_MODULE_0__ChatSidePanelWidgets_LoggedDetails_vue___default.a,
        'online-users': __WEBPACK_IMPORTED_MODULE_1__ChatSidePanelWidgets_OnlineUsers_vue___default.a,
        'user-chats': __WEBPACK_IMPORTED_MODULE_2__ChatSidePanelWidgets_UserChats_vue___default.a,
        'group-details': __WEBPACK_IMPORTED_MODULE_3__ChatSidePanelWidgets_GroupDetails_vue___default.a
    },

    data: function data() {
        return {
            fullSidePanelMode: false
        };
    },


    computed: {
        activeChatId: function activeChatId() {
            return this.$store.state.activeChatModel.id;
        },
        activeChatType: function activeChatType() {
            return !this.activeChatId ? '' : this.activeChatId.split('.')[0];
        },
        selectedTheme: function selectedTheme() {
            return this.$store.state.loggedUserModel.info.theme;
        },
        isRolledOut: function isRolledOut() {
            return this.$store.state.chatroomConfigModel.fullSidePanelMode;
        }
    },

    methods: {
        toggleRollOut: function toggleRollOut() {
            this.$store.dispatch('chatroomConfigModel/setFullSidePanelMode', !this.isRolledOut);
        }
    },

    watch: {
        '$store.state.activeChatModel.id': function $storeStateActiveChatModelId() {
            this.fullSidePanelMode = false;
        }
    }

});

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'GroupDetails',

    data: function data() {
        return {
            fetchedInitialGroupDetails: false,
            inviteMemberMode: false,
            leaveGroupMode: false,
            changeGroupNameMode: false,
            newGroupName: '',
            savingNewGroupName: false,
            newOwner: 0,
            inviteMemberValue: '',
            inviteMembersList: [],
            groupDetails: {
                name: '',
                members: [],
                isPublic: 0
            },
            isSavingPublicStatus: false
        };
    },


    computed: {
        groupId: function groupId() {
            return this.$store.state.activeChatModel.id.split('.')[1];
        },
        onlineUsers: function onlineUsers() {
            return this.$store.state.onlineUsersModel.onlineUsers;
        },
        ownId: function ownId() {
            return this.$store.state.loggedUserModel.info.id;
        },
        moderatorStatus: function moderatorStatus() {
            var _this = this;

            var status = '';

            this.groupDetails.members.forEach(function (member) {
                if (member.id === _this.ownId) {
                    status = member.moderatorStatus;
                    return false;
                }
            });

            return status;
        },
        filteredInviteMembersList: function filteredInviteMembersList() {
            var _this2 = this;

            var filteredList = [];

            this.inviteMembersList.forEach(function (member) {
                if (!_this2.memberIsInGroup(member)) {
                    filteredList.push(member);
                }
            });

            return filteredList;
        }
    },

    methods: {
        avatarImage: function avatarImage(user) {
            var avatarId = new Date(user.avatarUpdate).getTime();

            if (user.hasAvatar) {
                return '/userdata/avatars/' + user.id + '.jpg?v=' + avatarId;
            } else {
                return '/defaultProfilePic.png';
            }
        },
        fetchGroupDetails: function fetchGroupDetails() {
            var _this3 = this;

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/groups', {
                params: {
                    groupId: this.groupId
                }
            }).then(function (response) {
                if (response.data.errors) {
                    return;
                }

                _this3.fetchedInitialGroupDetails = true;
                _this3.newGroupName = response.data.groupData.alias;

                for (var i = 0; i < response.data.members.length; i++) {
                    if (response.data.members[i].id !== _this3.ownId) {
                        _this3.newOwner = response.data.members[i].id;
                        break;
                    }
                }

                _this3.groupDetails = {
                    name: response.data.groupData.alias,
                    members: response.data.members,
                    isPublic: response.data.groupData.isPublic
                };
            });
        },
        updateGroupName: function updateGroupName() {
            this.newGroupName = this.newGroupName.trim();

            if (this.newGroupName === '') {
                return;
            }

            this.savingNewGroupName = true;

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/groups/updateGroupName', {
                groupId: this.groupId,
                groupName: this.newGroupName
            });
        },
        leaveGroup: function leaveGroup() {
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/groups/leaveGroup', {
                groupId: this.groupId,
                newOwner: this.newOwner
            });
        },
        memberIsInGroup: function memberIsInGroup(user) {
            var isInGroup = false;

            this.groupDetails.members.forEach(function (member) {
                if (member.id === user.id) {
                    isInGroup = true;
                    return false;
                }
            });

            return isInGroup;
        },


        fetchMatchingMembers: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(function () {
            var _this4 = this;

            this.inviteMemberValue = this.inviteMemberValue.trim();
            if (this.inviteMemberValue === '') {
                return;
            }

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/member/search', {
                params: {
                    searchValue: this.inviteMemberValue
                }
            }).then(function (response) {
                if (!response.data.errors) {
                    _this4.inviteMembersList = response.data;
                }
            });
        }, 500),

        addMember: function addMember(user) {
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/groups/addMember', {
                groupId: this.groupId,
                memberId: user.id
            });
        },
        kick: function kick(user) {
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/groups/kickMember', {
                groupId: this.groupId,
                memberId: user.id
            });
        },
        promote: function promote(user) {
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/groups/promoteMember', {
                groupId: this.groupId,
                memberId: user.id
            });
        },
        demote: function demote(user) {
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/groups/demoteMember', {
                groupId: this.groupId,
                memberId: user.id
            });
        },
        changePublicStatus: function changePublicStatus(publicStatus) {
            var _this5 = this;

            if (this.isSavingPublicStatus) {
                return;
            }

            this.$set(this.groupDetails, 'isPublic', publicStatus);
            this.isSavingPublicStatus = true;

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/groups/setPublicStatus', {
                groupId: this.groupId,
                publicStatus: publicStatus ? 1 : 0
            }).then(function (response) {
                _this5.isSavingPublicStatus = false;
            }, function (response) {
                _this5.isSavingPublicStatus = false;
            });
        }
    },

    mounted: function mounted() {
        this.fetchGroupDetails();
    },


    watch: {
        'groupId': function groupId() {
            this.changeGroupNameMode = false;
            this.leaveGroupMode = false;
            this.inviteMemberMode = false;
            this.fetchGroupDetails();
        },
        'inviteMemberValue': function inviteMemberValue() {
            this.fetchMatchingMembers();
        }
    },

    sockets: {
        'groupDataUpdated': function groupDataUpdated() {
            this.savingNewGroupName = false;
            this.changeGroupNameMode = false;
            this.fetchGroupDetails();
        }
    }
});

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'LoggedDetails',

    data: function data() {
        return {
            showFriendRequests: false,
            retrievedPendingFriendRequests: false,
            pendingFriendRequests: [],
            settingsMode: false,
            savingSettings: false,
            useSwearFilter: true,
            useMetric: false,
            ignoreThreshold: 90
        };
    },


    computed: {
        loggedUser: function loggedUser() {
            var loggedUser = this.$store.state.loggedUserModel;
            if (loggedUser.isLoggedIn) {
                return loggedUser.info;
            }
        },
        avatarImage: function avatarImage() {
            var avatarId = new Date(this.loggedUser.avatarUpdate).getTime();
            if (this.loggedUser && this.loggedUser.hasAvatar) {
                return '/userdata/avatars/' + this.loggedUser.id + '.jpg?v=' + avatarId;
            } else {
                return '/defaultProfilePic.png';
            }
        }
    },

    methods: {
        logout: function logout() {
            var _this = this;

            this.$store.dispatch('loggedUserModel/logOut', function () {
                _this.$router.push('/');
            });
        },
        uploadNewAvatar: function uploadNewAvatar(e) {
            var input = e.target,
                avatarFile = void 0,
                formData = new FormData();

            if (input.files.length === 0) {
                return;
            }

            avatarFile = input.files[0];

            if (input.files[0].size > 2 * 1024 * 1024) {
                return;
            }

            formData.append('avatarFile', avatarFile);

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/member/newAvatar', formData);
        },
        generateFriendRequestAvatar: function generateFriendRequestAvatar(friendRequest) {
            var avatarId = new Date(friendRequest.senderAvatarUpdate).getTime();

            if (friendRequest.senderHasAvatar) {
                return '/userdata/avatars/' + friendRequest.senderId + '.jpg?v=' + avatarId;
            } else {
                return '/defaultProfilePic.png';
            }
        },
        fetchPendingFriendRequests: function fetchPendingFriendRequests() {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/friendRequests').then(function (response) {
                if (response.data.error) {
                    return;
                }

                _this2.retrievedPendingFriendRequests = true;
                _this2.pendingFriendRequests = response.data.requests;
            });
        },
        acceptFriendRequest: function acceptFriendRequest(friendRequest) {
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/friendRequests/accept', {
                friendId: friendRequest.senderId
            });
        },
        declineFriendRequest: function declineFriendRequest(friendRequest) {
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/friendRequests/decline', {
                friendId: friendRequest.senderId
            });
        },
        saveSettings: function saveSettings() {
            var _this3 = this;

            this.savingSettings = true;

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/member/settings', {
                useSwearFilter: this.useSwearFilter,
                useMetric: this.useMetric,
                ignoreThreshold: this.ignoreThreshold
            }).then(function (response) {
                _this3.$store.dispatch('loggedUserModel/fetchLoggedUserInfo');
                _this3.savingSettings = false;
                _this3.settingsMode = false;
            });
        }
    },

    mounted: function mounted() {
        this.fetchPendingFriendRequests();

        if (this.$store.state.loggedUserModel.isLoggedIn) {
            this.useSwearFilter = this.$store.state.loggedUserModel.info.useSwearFilter;
            this.useMetric = this.$store.state.loggedUserModel.info.useMetric;
            this.ignoreThreshold = this.$store.state.loggedUserModel.info.ignoreThreshold;
        }
    },


    sockets: {
        'updateFriendStatus': function updateFriendStatus() {
            this.fetchPendingFriendRequests();
        }
    }

});

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'OnlineUsers',

    methods: {
        avatarImage: function avatarImage(user) {
            var avatarId = new Date(user.avatarUpdate).getTime();

            if (user.hasAvatar) {
                return '/userdata/avatars/' + user.id + '.jpg?v=' + avatarId;
            } else {
                return '/defaultProfilePic.png';
            }
        }
    },

    computed: {
        onlineUsers: function onlineUsers() {
            return this.$store.state.onlineUsersModel.onlineUsers;
        }
    }
});

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'UserChats',
    data: function data() {
        return {
            addGroupMode: false,
            newGroupName: '',
            savingNewGroup: false
        };
    },


    computed: {
        chatId: function chatId() {
            return this.$store.state.activeChatModel.id;
        },
        PublicChats: function PublicChats() {
            return this.$store.state.publicChatsModel.publicChatrooms;
        },
        groupChats: function groupChats() {
            return this.$store.state.groupChatsModel.groupChatrooms;
        },
        friendChats: function friendChats() {
            var _this = this;

            var friendChats = this.$store.state.friendChatsModel.friendChatrooms;

            friendChats.forEach(function (friendChat) {
                friendChat.isOnline = _this.onlineUsers[friendChat.stringUrl] !== undefined;
            });

            friendChats.sort(function (a, b) {
                if (a.unreadMessages > b.unreadMessages) return -1;
                if (a.unreadMessages < b.unreadMessages) return 1;
                if (a.isOnline && !b.isOnline) return -1;
                if (!a.isOnline && b.isOnline) return 1;
                if (a.alias.toLowerCase() < b.alias.toLowerCase()) return -1;
                if (a.alias.toLowerCase() > b.alias.toLowerCase()) return 1;
                return 0;
            });

            return friendChats;
        },
        onlineUsers: function onlineUsers() {
            return this.$store.state.onlineUsersModel.onlineUsers;
        }
    },

    methods: {
        switchToChat: function switchToChat(newChatId) {
            this.$store.commit('activeChatModel/setActiveChat', newChatId);
        },
        generateAvatarImage: function generateAvatarImage(friend) {
            var avatarId = new Date(friend.avatarUpdate).getTime();

            if (friend.hasAvatar) {
                return '/userdata/avatars/' + friend.id + '.jpg?v=' + avatarId;
            } else {
                return '/defaultProfilePic.png';
            }
        },
        isOnline: function isOnline(friend) {
            var foundFriend = false;

            this.onlineUsers.forEach(function (onlineUser) {
                if (onlineUser.id === friend.id) {
                    foundFriend = true;
                    return false;
                }
            });

            return foundFriend;
        },
        createNewGroup: function createNewGroup() {
            var _this2 = this;

            this.newGroupName = this.newGroupName.trim();

            if (this.newGroupName === '') {
                return;
            }

            this.savingNewGroup = true;

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/groups/newGroup', {
                groupName: this.newGroupName
            }).then(function (response) {
                _this2.addGroupMode = false;
                _this2.savingNewGroup = false;
                _this2.newGroupName = '';
            });
        }
    },

    mounted: function mounted() {
        this.$store.dispatch('publicChatsModel/fetchPublicChats');
        this.$store.dispatch('groupChatsModel/fetchGroupChats');
        this.$store.dispatch('friendChatsModel/fetchFriendChats');
    },


    sockets: {
        'updateFriendStatus': function updateFriendStatus() {
            this.$store.dispatch('friendChatsModel/fetchFriendChats');
        },
        'updateGroupChats': function updateGroupChats() {
            this.$store.dispatch('groupChatsModel/fetchGroupChats');
        },
        'groupDataUpdated': function groupDataUpdated() {
            this.$store.dispatch('groupChatsModel/fetchGroupChats');
        },
        'updateChatRoomList': function updateChatRoomList(data) {
            if (data.chatId === this.chatId) {
                return;
            }

            data.type = data.chatId.split('.')[0];

            if (data.type === 'public') {
                this.$store.dispatch('publicChatsModel/fetchPublicChats');
            }

            if (data.type === 'group') {
                this.$store.dispatch('groupChatsModel/fetchGroupChats');
            }

            if (data.type === 'private') {
                this.$store.dispatch('friendChatsModel/fetchFriendChats');
            }
        }
    }
});

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AdSense_vue__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AdSense_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__AdSense_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'CompanionAdContainer',
    props: ['adSlot'],

    data: function data() {
        return {};
    },


    components: {
        'adsense': __WEBPACK_IMPORTED_MODULE_0__AdSense_vue___default.a
    }
});

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        adClient: {
            type: String,
            required: true
        },
        adSlot: {
            type: String,
            required: true
        },
        adFormat: {
            type: String,
            required: false,
            default: 'auto'
        },
        adStyle: {
            type: String,
            required: false,
            default: 'display: block'
        }
    },
    mounted: function mounted() {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
    }
});

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'FakeYoutube',
    props: ['src'],

    data: function data() {
        return {
            expanded: false
        };
    },


    computed: {
        videoCode: function videoCode() {
            return this.src;

            var matched = this.src.match("v=([a-zA-Z0-9\_\-]+)&?");

            if (matched && matched.length > 1) {
                return matched[1];
            } else {
                return this.src.split('/')[this.src.split('/').length - 1];
            }
        }
    }
});

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'LoadingLarge'
});

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'LoadingSmall'
});

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'SavingLarge'
});

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'MarkdownContent',
    props: ['content', 'classes'],

    render: function render(createElement) {
        var children = [];
        var index = 0;

        if (index < this.content.length) {
            children.push(createElement('div', {
                domProps: {
                    innerHTML: this.$options.filters.markdown(this.content.slice(index))
                }
            }));
        }

        return createElement('section', {
            'class': this.classes
        }, children);
    }
});

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GlobalBus__ = __webpack_require__(57);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Modal',
    data: function data() {
        return {
            showModal: false,
            modalContent: undefined
        };
    },
    created: function created() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_0__GlobalBus__["a" /* default */].$on('openModal', function (content) {
            _this.modalContent = content;
            _this.showModal = true;
        });
    },


    methods: {
        closeModal: function closeModal() {
            this.showModal = false;
        }
    }
});

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LoginForm_vue__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LoginForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__LoginForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RegisterForm_vue__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RegisterForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__RegisterForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Common_AdContainer_vue__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Common_AdContainer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Common_AdContainer_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'HomePage',

    components: {
        'login-form': __WEBPACK_IMPORTED_MODULE_0__LoginForm_vue___default.a,
        'register-form': __WEBPACK_IMPORTED_MODULE_1__RegisterForm_vue___default.a,
        'ad-container': __WEBPACK_IMPORTED_MODULE_2__Common_AdContainer_vue___default.a
    },

    data: function data() {
        return {
            failedLogin: false,
            showLoginForm: false,
            showRegisterForm: false
        };
    },


    computed: {
        shouldShowLandingPage: function shouldShowLandingPage() {
            var cookieEntries = document.cookie.split(';');
            var cookies = {};

            cookieEntries.forEach(function (cookie) {
                var cookieSegments = cookie.split('=');
                if (cookieSegments.length === 2) {
                    cookies[cookieSegments[0].trim()] = cookieSegments[1].trim();
                }
            });

            return !cookies.passKey || !cookies.password;
        },
        fetchedLoginStatus: function fetchedLoginStatus() {
            return !this.$store.state.loggedUserModel.gotInitialLoggedUserInfo;
        }
    },

    methods: {
        toggleLoginForm: function toggleLoginForm() {
            this.showLoginForm = !this.showLoginForm;
        }
    },
    watch: {
        'fetchedLoginStatus': function fetchedLoginStatus() {
            if (this.$store.state.loggedUserModel.isLoggedIn) {
                this.$router.push('/Chat');
            } else {
                this.failedLogin = true;
            }
        }
    }
});

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_validator__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_validator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_validator__);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'LoginForm',

    data: function data() {
        return {
            errors: [],
            email: '',
            password: '',
            rememberMe: true
        };
    },


    methods: {
        submit: function submit() {
            var _this = this;

            var errors = [];

            this.email = this.email.trim();

            if (!__WEBPACK_IMPORTED_MODULE_1_validator___default.a.isEmail(this.email)) {
                errors.push('Invalid Email Address');
            }

            if (this.password === '') {
                errors.push('Enter your Password');
            }

            if (errors.length > 0) {
                this.errors = errors;
                return;
            }

            this.isSaving = true;

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/login', {
                email: this.email,
                password: this.password
            }).then(function (response) {
                if (response.data.errors) {
                    _this.isSaving = false;
                    _this.errors = response.data.errors;
                    return;
                }

                _this.$store.dispatch('loggedUserModel/fetchLoggedUserInfo', function () {
                    _this.$socket.emit("setUserSocketData", _this.$store.state.loggedUserModel.info);
                    _this.$router.push('/Chat');
                });
            }, function (response) {
                _this.isSaving = false;
                _this.errors = ['There was a problem connecting to the Database. Please wait a minute and try again.'];
            });
        }
    },

    mounted: function mounted() {
        this.$refs.emailField.focus();
    }
});

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_validator__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_validator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_validator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'RegisterForm',

    data: function data() {
        return {
            errors: [],
            isSaving: false,
            alias: '',
            email: '',
            password: '',
            passwordVerify: '',
            gender: 'Male',
            agreesToToc: false,
            agreesToAge: false
        };
    },


    methods: {
        submit: function submit() {
            var _this = this;

            var errors = [];

            this.alias = this.alias.trim();
            this.email = this.email.trim();

            if (this.alias.trim() === '') {
                errors.push('No User Name Entered');
            }

            if (!__WEBPACK_IMPORTED_MODULE_0_validator___default.a.isEmail(this.email)) {
                errors.push('Invalid Email Address');
            }
            if (this.password === '') {
                errors.push('No Password Entered');
            } else if (this.password !== this.passwordVerify) {
                errors.push('Passwords Don\'t Match');
            }

            if (!this.agreesToToc) {
                errors.push("You Must Agree to the Terms and Conditions");
            }

            if (!this.agreesToAge) {
                errors.push("You Must be 13+ years old");
            }

            if (errors.length > 0) {
                this.errors = errors;
                return;
            }

            this.isSaving = true;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/api/register', {
                alias: this.alias,
                email: this.email,
                password: this.password,
                gender: this.gender
            }).then(function (response) {
                if (response.data.errors) {
                    _this.isSaving = false;
                    _this.errors = response.data.errors;
                    return;
                }

                _this.$store.dispatch('loggedUserModel/fetchLoggedUserInfo', function () {
                    _this.$socket.emit("setUserSocketData", _this.$store.state.loggedUserModel.info);
                    _this.$router.push('/Chat');
                });
            }, function (response) {
                _this.isSaving = false;
                _this.errors = ['There was a problem connecting to the Database. Please wait a minute and try again.'];
            });
        }
    }
});

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Chatroom_ChatSidePanel_vue__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Chatroom_ChatSidePanel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Chatroom_ChatSidePanel_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Chatroom_ActiveChatsPanel_vue__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Chatroom_ActiveChatsPanel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Chatroom_ActiveChatsPanel_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ChatRoom_ChatPanel_vue__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ChatRoom_ChatPanel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ChatRoom_ChatPanel_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);








/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ChatLayout',
    components: {
        'chat-side-panel': __WEBPACK_IMPORTED_MODULE_0__Chatroom_ChatSidePanel_vue___default.a,
        'active-chats-panel': __WEBPACK_IMPORTED_MODULE_1__Chatroom_ActiveChatsPanel_vue___default.a,
        'chat-panel': __WEBPACK_IMPORTED_MODULE_2__ChatRoom_ChatPanel_vue___default.a
    },

    computed: {
        fetchingLoginStatus: function fetchingLoginStatus() {
            return !this.$store.state.loggedUserModel.gotInitialLoggedUserInfo;
        },
        isLoggedIn: function isLoggedIn() {
            return this.$store.state.loggedUserModel.isLoggedIn;
        },
        isRolledOut: function isRolledOut() {
            return this.$store.state.chatroomConfigModel.fullSidePanelMode;
        }
    },

    methods: {
        'clearTitle': function clearTitle() {
            if (this.$store.state.titleBarModel.alert) {
                this.$store.state.titleBarModel.alert = undefined;
            }
        }
    },
    mounted: function mounted() {
        this.$store.commit('activeChatModel/setActiveChat', 'public.1');
        this.$store.dispatch('ignoredUsersModel/fetchIgnoredUsers');
    },


    sockets: {
        'returnToPublic': function returnToPublic() {
            this.$store.commit('activeChatModel/setActiveChat', 'public.1');
        }
    }
});

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HomePage_HomePage_vue__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HomePage_HomePage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__HomePage_HomePage_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'HomeLayout',
    components: {
        'home-page': __WEBPACK_IMPORTED_MODULE_0__HomePage_HomePage_vue___default.a
    }
});

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HomePage_HomePage_vue__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HomePage_HomePage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__HomePage_HomePage_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'HomeLayout',
    components: {
        'home-page': __WEBPACK_IMPORTED_MODULE_0__HomePage_HomePage_vue___default.a
    }
});

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProfilePage_ProfilePage_vue__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProfilePage_ProfilePage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ProfilePage_ProfilePage_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ProfileLayout',
    components: {
        'profile-page': __WEBPACK_IMPORTED_MODULE_0__ProfilePage_ProfilePage_vue___default.a
    }
});

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'PrivacyPolicy'
});

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'TermsAndConditions'
});

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'BrowseMoreProfiles',
    props: ['currentMemberId'],

    data: function data() {
        return {
            browseMembers: []
        };
    },


    methods: {
        avatarImage: function avatarImage(user) {
            var avatarId = new Date(user.avatarUpdate).getTime();
            if (user.hasAvatar) {
                return '/userdata/avatars/' + user.id + '.jpg?v=' + avatarId;
            } else {
                return '/defaultProfilePic.png';
            }
        }
    },

    mounted: function mounted() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/browseMembers', {
            params: {
                currentMemberId: this.currentMemberId
            }
        }).then(function (response) {
            if (response.errors) {
                return;
            }

            _this.browseMembers = response.data.members;
        });
    }
});

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GlobalBus__ = __webpack_require__(57);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'PhotoManager',
    props: ['photos', 'isOwnProfile', 'memberId'],

    data: function data() {
        return {
            isUploading: false,
            deletingPhoto: false
        };
    },


    methods: {
        uploadPhoto: function uploadPhoto(e) {
            var _this = this;

            var input = e.target,
                file = void 0,
                formData = new FormData();

            if (input.files.length === 0) {
                return;
            }

            file = input.files[0];

            if (input.files[0].size > 2 * 1024 * 1024) {
                return;
            }

            this.isUploading = true;

            formData.append('uploadedFile', file);

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/photoUploader', formData).then(function (response) {
                console.log(response.data);
                console.log(response);
                _this.isUploading = false;

                if (!response.data.errors && response.data.response === 'success') {}
            });
        },
        deletePhoto: function deletePhoto(photo) {
            var _this2 = this;

            this.deletingPhoto = true;

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/photoUploader/delete', {
                photoId: photo.id
            }).then(function (response) {
                _this2.deletingPhoto = false;
            });
        },
        showInModal: function showInModal(photo) {
            __WEBPACK_IMPORTED_MODULE_1__GlobalBus__["a" /* default */].$emit('openModal', '<img src="/profilePhotos/member_' + this.memberId + '/' + photo.photoUrl + '"/>');
        }
    }

});

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BrowseMoreProfiles_vue__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BrowseMoreProfiles_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__BrowseMoreProfiles_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PhotoManager_vue__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PhotoManager_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__PhotoManager_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Common_AdContainer_vue__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Common_AdContainer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Common_AdContainer_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ProfilePage',

    components: {
        'browse-more-profiles': __WEBPACK_IMPORTED_MODULE_1__BrowseMoreProfiles_vue___default.a,
        'photo-manager': __WEBPACK_IMPORTED_MODULE_2__PhotoManager_vue___default.a,
        'ad-container': __WEBPACK_IMPORTED_MODULE_3__Common_AdContainer_vue___default.a
    },

    data: function data() {
        return {
            errors: [],
            fetchingProfileData: true,
            profileData: {},
            isUpdatingFriendStatus: false,
            retrievedFriendStatus: false,
            friendStatus: '',
            deleteFriendMode: false,
            editProfileMode: false,
            editDetails: {},
            editBioContent: '',
            editBioMode: false
        };
    },


    computed: {
        compoundStats: function compoundStats() {
            var stats = [];
            if (this.profileData.gender !== 'nospec') {
                stats.push(this.profileData.gender);
            }

            if (this.profileData.showAge) {
                var birthdayDate = new Date();
                birthdayDate.setFullYear(this.profileData.birthYear);
                birthdayDate.setMonth(this.profileData.birthMonth);
                birthdayDate.setDate(this.profileData.birthDay);
                birthdayDate.setHours(0);
                birthdayDate.setMinutes(0);
                birthdayDate.setSeconds(0);

                stats.push(new Date(Date.now() - birthdayDate.getTime()).getUTCFullYear() - 1970 + ' years old');
            }

            if (this.profileData.showHeight) {
                if (this.useMetric) {
                    stats.push(this.metricHeight + 'cm tall');
                } else {
                    stats.push(this.profileData.heightFeet + '\'' + this.profileData.heightInches + '" tall');
                }
            }

            return stats.join(', ');
        },
        useMetric: function useMetric() {
            return this.$store.state.loggedUserModel.isLoggedIn ? this.$store.state.loggedUserModel.info.useMetric : false;
        },
        metricHeight: function metricHeight() {
            var cm = (this.profileData.heightFeet * 12 + this.profileData.heightInches) * 2.54;
            cm = Math.round(cm);

            return cm;
        },
        avatarImage: function avatarImage() {
            var avatarId = new Date(this.profileData.avatarUpdate).getTime();
            return this.profileData.hasAvatar ? '/userdata/avatars/' + this.profileData.id + '.jpg?' + avatarId : '/defaultProfilePic.png';
        },
        isOwnProfile: function isOwnProfile() {
            return this.$store.state.loggedUserModel.isLoggedIn && this.$store.state.loggedUserModel.info.stringUrl === this.$route.params.stringUrl;
        },
        buttonToUse: function buttonToUse() {
            if (this.isOwnProfile) {
                return 'editProfile';
            }

            if (this.friendStatus === 'notFriends') {
                return 'addFriend';
            }

            if (this.friendStatus === 'friends') {
                return 'removeFriend';
            }

            if (this.friendStatus === 'friendRequestSent') {
                return 'friendRequestSent';
            }

            if (this.friendStatus === 'friendRequestReceived') {
                return 'acceptFriend';
            }

            return '';
        }
    },

    methods: {
        fetchProfileData: function fetchProfileData(callback) {
            var _this = this;

            var stringUrl = this.$route.params.stringUrl;

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/member', {
                params: {
                    stringUrl: stringUrl
                }
            }).then(function (response) {
                _this.fetchingProfileData = false;

                if (response.data.errors) {
                    _this.errors = response.data.errors;
                    if (callback) {
                        callback(false);
                    }
                    return;
                }

                _this.profileData = response.data;

                __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/member/profileView', {
                    profileId: _this.profileData.id
                });

                if (callback) {
                    callback(true);
                }
            }, function (response) {
                _this.errors = ['There was no response from the server. Please wait a minute and try again.'];
                _this.fetchingProfileData = false;

                if (callback) {
                    callback(false);
                }
            });
        },
        fetchFriendStatus: function fetchFriendStatus() {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/friendStatus', {
                params: {
                    friendId: this.profileData.id
                }
            }).then(function (response) {
                if (response.data.errors) {
                    _this2.errors = response.data.errors;
                    return;
                }

                _this2.friendStatus = response.data.response;
                _this2.retrievedFriendStatus = true;
            }, function (response) {
                _this2.errors = ['There was no response from the server. Please wait a minute and try again.'];
            });
        },
        addFriend: function addFriend() {
            var _this3 = this;

            this.isUpdatingFriendStatus = true;

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/friendRequests/add', {
                friendId: this.profileData.id
            }).then(function (response) {
                _this3.isUpdatingFriendStatus = false;
            }, function (response) {
                _this3.isUpdatingFriendStatus = false;
            });
        },
        acceptFriendRequest: function acceptFriendRequest() {
            var _this4 = this;

            this.isUpdatingFriendStatus = true;

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/friendRequests/accept', {
                friendId: this.profileData.id
            }).then(function (response) {
                _this4.isUpdatingFriendStatus = false;
            }, function (response) {
                _this4.isUpdatingFriendStatus = false;
            });
        },
        removeFriend: function removeFriend() {
            var _this5 = this;

            this.isUpdatingFriendStatus = true;

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/friendRequests/remove', {
                friendId: this.profileData.id
            }).then(function (response) {
                _this5.isUpdatingFriendStatus = false;
            }, function (response) {
                _this5.isUpdatingFriendStatus = false;
            });
        },
        saveProfileData: function saveProfileData() {
            var _this6 = this;

            if (this.useMetric) {
                var totalInches = 0.39 * this.editDetails.metricHeight;
                this.editDetails.heightFeet = Math.floor(totalInches / 12);
                this.editDetails.heightInches = totalInches - this.editDetails.heightFeet * 12;
            }

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/member', this.editDetails).then(function (response) {
                _this6.fetchProfileData(function (isSuccessful) {
                    _this6.editProfileMode = false;
                });
            });
        },
        saveBio: function saveBio() {
            var _this7 = this;

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/member/bio', { bio: this.editBioContent }).then(function (response) {
                _this7.fetchProfileData(function (isSuccessful) {
                    _this7.editBioMode = false;
                });
            });
        },


        yearRange: function yearRange(min) {
            var array = [],
                max = new Date().getFullYear() - 13,
                j = 0;

            for (var i = min; i <= max; i++) {
                array[j] = i;
                j++;
            }

            return array.reverse();
        }
    },

    watch: {
        'profileData': function profileData() {
            this.editDetails = {
                realName: this.profileData.realName,
                showAge: !!this.profileData.showAge,
                birthMonth: this.profileData.birthMonth,
                birthDay: this.profileData.birthDay,
                birthYear: this.profileData.birthYear,
                location: this.profileData.location,
                gender: this.profileData.gender,
                showHeight: this.profileData.showHeight,
                heightFeet: this.profileData.heightFeet,
                heightInches: this.profileData.heightInches,
                metricHeight: 0
            };

            this.editBioContent = this.profileData.bio;
        },
        'metricHeight': function metricHeight() {
            this.$set(this.editDetails, 'metricHeight', this.metricHeight);
        }
    },

    mounted: function mounted() {
        var _this8 = this;

        setTimeout(function () {
            _this8.fetchProfileData(function (isSuccessful) {
                if (isSuccessful) {
                    _this8.fetchFriendStatus();
                }
            });
        }, 500);
    },


    sockets: {
        'updateFriendStatus': function updateFriendStatus() {
            this.deleteFriendMode = false;
            this.fetchFriendStatus();
        },
        'profilePhotoUploaded': function profilePhotoUploaded(data) {
            if (data.memberId === this.profileData.id) {
                this.fetchProfileData();
            }
        }
    }
});

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



/* harmony default export */ __webpack_exports__["a"] = ({
    state: {
        id: ''
    },

    actions: {},

    mutations: {
        'activeChatModel/setActiveChat': function activeChatModelSetActiveChat(state, id) {
            state.id = id;
        }
    }

});

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	state: {
		fullSidePanelMode: false
	},

	actions: {
		'chatroomConfigModel/setFullSidePanelMode': function chatroomConfigModelSetFullSidePanelMode(context, data) {
			context.commit('chatroomConfigModel/setFullSidePanelMode', data);
		}
	},

	mutations: {
		'chatroomConfigModel/setFullSidePanelMode': function chatroomConfigModelSetFullSidePanelMode(state, data) {
			state.fullSidePanelMode = data;
		}
	}

});

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



/* harmony default export */ __webpack_exports__["a"] = ({
    state: {
        retrievedData: false,
        friendChatrooms: []
    },

    actions: {
        'friendChatsModel/fetchFriendChats': function friendChatsModelFetchFriendChats(context, data, callback) {
            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/api/friendChatRooms').then(function (response) {
                context.commit('friendChatsModel/setFriendChatrooms', response.data);

                if (callback && typeof callback === 'function') {
                    callback();
                }
            });
        }
    },

    mutations: {
        'friendChatsModel/setFriendChatrooms': function friendChatsModelSetFriendChatrooms(state, data) {
            state.retrievedData = true;
            state.friendChatrooms = data;
        },

        'friendChatsModel/clearReadMessages': function friendChatsModelClearReadMessages(state, data) {
            state.friendChatrooms.forEach(function (chatroom) {
                if (chatroom.friendChatId === data.chatId) {
                    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(chatroom, 'unreadMessages', 0);
                }
            });
        }
    }

});

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



/* harmony default export */ __webpack_exports__["a"] = ({
    state: {
        retrievedData: false,
        groupChatrooms: []
    },

    actions: {
        'groupChatsModel/fetchGroupChats': function groupChatsModelFetchGroupChats(context, data, callback) {
            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/api/groupChatrooms').then(function (response) {
                context.commit('groupChatsModel/setGroupChatrooms', response.data);

                if (callback && typeof callback === 'function') {
                    callback();
                }
            });
        }
    },

    mutations: {
        'groupChatsModel/setGroupChatrooms': function groupChatsModelSetGroupChatrooms(state, data) {
            state.retrievedData = true;
            state.groupChatrooms = data;
        },

        'groupChatsModel/clearReadMessages': function groupChatsModelClearReadMessages(state, data) {
            state.groupChatrooms.forEach(function (chatroom) {
                if (chatroom.id === data.chatId) {
                    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(chatroom, 'unreadMessages', 0);
                }
            });
        }
    }

});

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



/* harmony default export */ __webpack_exports__["a"] = ({
    state: {
        ignoredUsers: []
    },

    actions: {
        'ignoredUsersModel/fetchIgnoredUsers': function ignoredUsersModelFetchIgnoredUsers(context, data) {
            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/api/ignoreUser').then(function (response) {
                context.commit('ignoredUsersModel/setIgnoredUsers', response.data.ignoredUsers);
            });
        },
        'ignoredUsersModel/toggleIgnoreStatus': function ignoredUsersModelToggleIgnoreStatus(context, data) {
            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/api/ignoreUser', {
                ignoredId: data.ignoredId
            }).then(function (response) {
                if (data.callback && typeof data.callback === 'function') {
                    data.callback();
                }
            });
        }
    },

    mutations: {
        'ignoredUsersModel/setIgnoredUsers': function ignoredUsersModelSetIgnoredUsers(state, ignoredUsers) {
            state.ignoredUsers = ignoredUsers;
        }
    }

});

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



/* harmony default export */ __webpack_exports__["a"] = ({
    state: {
        onlineUsers: []
    },

    mutations: {
        'onlineUsersModel/setOnlineUsers': function onlineUsersModelSetOnlineUsers(state, onlineUsers) {
            var userList = {};

            onlineUsers.sort(function (a, b) {
                if (a.alias.toLowerCase() < b.alias.toLowerCase()) return -1;
                if (a.alias.toLowerCase() > b.alias.toLowerCase()) return 1;
                return 0;
            });
            onlineUsers.forEach(function (onlineUser) {
                userList[onlineUser.stringUrl] = onlineUser;
            });

            state.onlineUsers = userList;
        }
    }
});

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



/* harmony default export */ __webpack_exports__["a"] = ({
    state: {
        retrievedData: false,
        publicChatrooms: []
    },

    actions: {
        'publicChatsModel/fetchPublicChats': function publicChatsModelFetchPublicChats(context, data, callback) {
            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/api/publicChatRooms').then(function (response) {
                context.commit('publicChatsModel/setPublicChatrooms', response.data);

                if (callback && typeof callback === 'function') {
                    callback();
                }
            });
        }
    },

    mutations: {
        'publicChatsModel/setPublicChatrooms': function publicChatsModelSetPublicChatrooms(state, data) {
            state.retrievedData = true;
            state.publicChatrooms = data;
        },

        'publicChatsModel/clearReadMessages': function publicChatsModelClearReadMessages(state, data) {
            state.publicChatrooms.forEach(function (chatroom) {
                if (chatroom.id === data.chatId) {
                    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(chatroom, 'unreadMessages', 0);
                }
            });
        }
    }
});

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



/* harmony default export */ __webpack_exports__["a"] = ({
    state: {
        chatMessages: {}
    },

    actions: {
        'chatMessagesModel/fetchChatMessages': function chatMessagesModelFetchChatMessages(context, data) {
            var chatId = data.chatId,
                callback = data.callback;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/api/chatMessages', {
                params: {
                    chatId: chatId
                }
            }).then(function (response) {
                if (!response.data.errors) {
                    context.commit('chatMessagesModel/setChatMessages', { chatId: chatId, messages: response.data });
                }

                if (callback && typeof callback === 'function') {
                    callback();
                }
            });
        },

        'chatMessagesModel/sendMessage': function chatMessagesModelSendMessage(context, data) {

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/api/chatMessages', {
                chatId: data.chatId,
                message: data.message
            });
        },
        'chatMessagesModel/updateReadStatus': function chatMessagesModelUpdateReadStatus(context, data) {
            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/api/chatMessages/updateReadStatus', {
                chatId: data.chatId
            });
        }
    },

    mutations: {
        'chatMessagesModel/setChatMessages': function chatMessagesModelSetChatMessages(state, data) {
            __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state.chatMessages, data.chatId, data.messages);
        }
    }

});

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



/* harmony default export */ __webpack_exports__["a"] = ({
    state: {
        gotInitialLoggedUserInfo: false,
        isLoggedIn: false,
        info: []
    },

    actions: {
        'loggedUserModel/fetchLoggedUserInfo': function loggedUserModelFetchLoggedUserInfo(context, callback) {
            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/api/login').then(function (response) {
                context.commit('loggedUserModel/setLoggedUserInfo', response.data);
                context.state.gotInitialLoggedUserInfo = true;

                if (callback && typeof callback === 'function') {
                    callback(response.data);
                }
            });
        },
        'loggedUserModel/logOut': function loggedUserModelLogOut(context, callback) {
            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/api/login', {
                params: {
                    logOut: true
                }
            }).then(function (response) {
                if (callback && typeof callback === 'function') {
                    callback();
                }
            });
        }
    },

    mutations: {
        'loggedUserModel/setLoggedUserInfo': function loggedUserModelSetLoggedUserInfo(state, data) {
            state.isLoggedIn = data.isLoggedIn;
            state.info = data.info;
        },

        'loggedUserModel/unsetLoggedUserInfo': function loggedUserModelUnsetLoggedUserInfo(state) {
            state.isLoggedIn = false;
            state.info = {};
        }
    }

});

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



/* harmony default export */ __webpack_exports__["a"] = ({
    state: {
        originalTitle: 'Mixsii | Free Video Chat with Friends',
        defaultAlert: '▲',
        alert: undefined,
        divider: ' ',
        isVisible: true
    },

    actions: {},

    mutations: {
        'titleBarModel/updateAlert': function titleBarModelUpdateAlert(state, data) {
            this.alert = data.alert;
        }
    }

});

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Emitter__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_socket_io_client__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_socket_io_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_socket_io_client__);





var _class = function () {
    function _class(connection) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);

        if (typeof connection == 'string') {
            this.Socket = __WEBPACK_IMPORTED_MODULE_3_socket_io_client___default()(connection);
        } else {
            this.Socket = connection;
        }

        this.onEvent();
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, [{
        key: 'onEvent',
        value: function onEvent() {
            this.Socket.onevent = function (packet) {
                __WEBPACK_IMPORTED_MODULE_2__Emitter__["a" /* default */].emit(packet.data[0], packet.data[1]);
            };

            var _this = this;

            ["connect", "error", "disconnect", "reconnect", "reconnect_attempt", "reconnecting", "reconnect_error", "reconnect_failed"].forEach(function (value) {
                _this.Socket.on(value, function (data) {
                    __WEBPACK_IMPORTED_MODULE_2__Emitter__["a" /* default */].emit(value, data);
                });
            });
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 183 */
/***/ (function(module, exports) {

module.exports = function dtSmiley(md) {

    var defaultRender = md.renderer.rules.link_open || function (tokens, idx, options, env, self) {
        return self.renderToken(tokens, idx, options);
    };

    md.renderer.rules.link_open = function (tokens, idx, options, env, self) {
        var aIndex = tokens[idx].attrIndex('target');

        if (aIndex < 0) {
            tokens[idx].attrPush(['target', '_blank']);
        } else {
            tokens[idx].attrs[aIndex][1] = '_blank';
        }

        return defaultRender(tokens, idx, options, env, self);
    };
};

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main_less__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router_router__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ForkedModules_VueSocketIo_main__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vueFilters_js__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vueComponents_js__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__imageReloader__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_js__ = __webpack_require__(117);
__webpack_require__(120).polyfill();








 true ? __WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5__ForkedModules_VueSocketIo_main__["a" /* default */], 'https://www.mixsii.com/') : Vue.use(VueSocketio, 'http://127.0.0.1:82/');

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);






var store = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__store_js__["a" /* default */])({ Vue: __WEBPACK_IMPORTED_MODULE_1_vue__["default"], Vuex: __WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */] });

new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_4__router_router__["a" /* default */],
    store: store,
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a },

    sockets: {
        'serverReconnect': function serverReconnect() {
            var _this = this;

            store.dispatch('loggedUserModel/fetchLoggedUserInfo', function (user) {
                if (user.isLoggedIn) {
                    _this.$socket.emit("setUserSocketData", user.info);
                }
            });
        },
        'avatarUpdated': function avatarUpdated(data) {
            var _this2 = this;

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__imageReloader__["a" /* default */])('/userdata/avatars/' + data.id + '.jpg');

            store.dispatch('loggedUserModel/fetchLoggedUserInfo', function (user) {
                if (user.isLoggedIn) {
                    _this2.$socket.emit("setUserSocketData", user.info);
                }
            });
        },
        'loggedOut': function loggedOut() {
            store.commit('loggedUserModel/unsetLoggedUserInfo');
            this.$socket.emit("unsetUserSocketData");
        }
    }
});

/***/ }),
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */
/***/ (function(module, exports) {

module.exports = {"Aacute":"Á","aacute":"á","Abreve":"Ă","abreve":"ă","ac":"∾","acd":"∿","acE":"∾̳","Acirc":"Â","acirc":"â","acute":"´","Acy":"А","acy":"а","AElig":"Æ","aelig":"æ","af":"⁡","Afr":"𝔄","afr":"𝔞","Agrave":"À","agrave":"à","alefsym":"ℵ","aleph":"ℵ","Alpha":"Α","alpha":"α","Amacr":"Ā","amacr":"ā","amalg":"⨿","amp":"&","AMP":"&","andand":"⩕","And":"⩓","and":"∧","andd":"⩜","andslope":"⩘","andv":"⩚","ang":"∠","ange":"⦤","angle":"∠","angmsdaa":"⦨","angmsdab":"⦩","angmsdac":"⦪","angmsdad":"⦫","angmsdae":"⦬","angmsdaf":"⦭","angmsdag":"⦮","angmsdah":"⦯","angmsd":"∡","angrt":"∟","angrtvb":"⊾","angrtvbd":"⦝","angsph":"∢","angst":"Å","angzarr":"⍼","Aogon":"Ą","aogon":"ą","Aopf":"𝔸","aopf":"𝕒","apacir":"⩯","ap":"≈","apE":"⩰","ape":"≊","apid":"≋","apos":"'","ApplyFunction":"⁡","approx":"≈","approxeq":"≊","Aring":"Å","aring":"å","Ascr":"𝒜","ascr":"𝒶","Assign":"≔","ast":"*","asymp":"≈","asympeq":"≍","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","awconint":"∳","awint":"⨑","backcong":"≌","backepsilon":"϶","backprime":"‵","backsim":"∽","backsimeq":"⋍","Backslash":"∖","Barv":"⫧","barvee":"⊽","barwed":"⌅","Barwed":"⌆","barwedge":"⌅","bbrk":"⎵","bbrktbrk":"⎶","bcong":"≌","Bcy":"Б","bcy":"б","bdquo":"„","becaus":"∵","because":"∵","Because":"∵","bemptyv":"⦰","bepsi":"϶","bernou":"ℬ","Bernoullis":"ℬ","Beta":"Β","beta":"β","beth":"ℶ","between":"≬","Bfr":"𝔅","bfr":"𝔟","bigcap":"⋂","bigcirc":"◯","bigcup":"⋃","bigodot":"⨀","bigoplus":"⨁","bigotimes":"⨂","bigsqcup":"⨆","bigstar":"★","bigtriangledown":"▽","bigtriangleup":"△","biguplus":"⨄","bigvee":"⋁","bigwedge":"⋀","bkarow":"⤍","blacklozenge":"⧫","blacksquare":"▪","blacktriangle":"▴","blacktriangledown":"▾","blacktriangleleft":"◂","blacktriangleright":"▸","blank":"␣","blk12":"▒","blk14":"░","blk34":"▓","block":"█","bne":"=⃥","bnequiv":"≡⃥","bNot":"⫭","bnot":"⌐","Bopf":"𝔹","bopf":"𝕓","bot":"⊥","bottom":"⊥","bowtie":"⋈","boxbox":"⧉","boxdl":"┐","boxdL":"╕","boxDl":"╖","boxDL":"╗","boxdr":"┌","boxdR":"╒","boxDr":"╓","boxDR":"╔","boxh":"─","boxH":"═","boxhd":"┬","boxHd":"╤","boxhD":"╥","boxHD":"╦","boxhu":"┴","boxHu":"╧","boxhU":"╨","boxHU":"╩","boxminus":"⊟","boxplus":"⊞","boxtimes":"⊠","boxul":"┘","boxuL":"╛","boxUl":"╜","boxUL":"╝","boxur":"└","boxuR":"╘","boxUr":"╙","boxUR":"╚","boxv":"│","boxV":"║","boxvh":"┼","boxvH":"╪","boxVh":"╫","boxVH":"╬","boxvl":"┤","boxvL":"╡","boxVl":"╢","boxVL":"╣","boxvr":"├","boxvR":"╞","boxVr":"╟","boxVR":"╠","bprime":"‵","breve":"˘","Breve":"˘","brvbar":"¦","bscr":"𝒷","Bscr":"ℬ","bsemi":"⁏","bsim":"∽","bsime":"⋍","bsolb":"⧅","bsol":"\\","bsolhsub":"⟈","bull":"•","bullet":"•","bump":"≎","bumpE":"⪮","bumpe":"≏","Bumpeq":"≎","bumpeq":"≏","Cacute":"Ć","cacute":"ć","capand":"⩄","capbrcup":"⩉","capcap":"⩋","cap":"∩","Cap":"⋒","capcup":"⩇","capdot":"⩀","CapitalDifferentialD":"ⅅ","caps":"∩︀","caret":"⁁","caron":"ˇ","Cayleys":"ℭ","ccaps":"⩍","Ccaron":"Č","ccaron":"č","Ccedil":"Ç","ccedil":"ç","Ccirc":"Ĉ","ccirc":"ĉ","Cconint":"∰","ccups":"⩌","ccupssm":"⩐","Cdot":"Ċ","cdot":"ċ","cedil":"¸","Cedilla":"¸","cemptyv":"⦲","cent":"¢","centerdot":"·","CenterDot":"·","cfr":"𝔠","Cfr":"ℭ","CHcy":"Ч","chcy":"ч","check":"✓","checkmark":"✓","Chi":"Χ","chi":"χ","circ":"ˆ","circeq":"≗","circlearrowleft":"↺","circlearrowright":"↻","circledast":"⊛","circledcirc":"⊚","circleddash":"⊝","CircleDot":"⊙","circledR":"®","circledS":"Ⓢ","CircleMinus":"⊖","CirclePlus":"⊕","CircleTimes":"⊗","cir":"○","cirE":"⧃","cire":"≗","cirfnint":"⨐","cirmid":"⫯","cirscir":"⧂","ClockwiseContourIntegral":"∲","CloseCurlyDoubleQuote":"”","CloseCurlyQuote":"’","clubs":"♣","clubsuit":"♣","colon":":","Colon":"∷","Colone":"⩴","colone":"≔","coloneq":"≔","comma":",","commat":"@","comp":"∁","compfn":"∘","complement":"∁","complexes":"ℂ","cong":"≅","congdot":"⩭","Congruent":"≡","conint":"∮","Conint":"∯","ContourIntegral":"∮","copf":"𝕔","Copf":"ℂ","coprod":"∐","Coproduct":"∐","copy":"©","COPY":"©","copysr":"℗","CounterClockwiseContourIntegral":"∳","crarr":"↵","cross":"✗","Cross":"⨯","Cscr":"𝒞","cscr":"𝒸","csub":"⫏","csube":"⫑","csup":"⫐","csupe":"⫒","ctdot":"⋯","cudarrl":"⤸","cudarrr":"⤵","cuepr":"⋞","cuesc":"⋟","cularr":"↶","cularrp":"⤽","cupbrcap":"⩈","cupcap":"⩆","CupCap":"≍","cup":"∪","Cup":"⋓","cupcup":"⩊","cupdot":"⊍","cupor":"⩅","cups":"∪︀","curarr":"↷","curarrm":"⤼","curlyeqprec":"⋞","curlyeqsucc":"⋟","curlyvee":"⋎","curlywedge":"⋏","curren":"¤","curvearrowleft":"↶","curvearrowright":"↷","cuvee":"⋎","cuwed":"⋏","cwconint":"∲","cwint":"∱","cylcty":"⌭","dagger":"†","Dagger":"‡","daleth":"ℸ","darr":"↓","Darr":"↡","dArr":"⇓","dash":"‐","Dashv":"⫤","dashv":"⊣","dbkarow":"⤏","dblac":"˝","Dcaron":"Ď","dcaron":"ď","Dcy":"Д","dcy":"д","ddagger":"‡","ddarr":"⇊","DD":"ⅅ","dd":"ⅆ","DDotrahd":"⤑","ddotseq":"⩷","deg":"°","Del":"∇","Delta":"Δ","delta":"δ","demptyv":"⦱","dfisht":"⥿","Dfr":"𝔇","dfr":"𝔡","dHar":"⥥","dharl":"⇃","dharr":"⇂","DiacriticalAcute":"´","DiacriticalDot":"˙","DiacriticalDoubleAcute":"˝","DiacriticalGrave":"`","DiacriticalTilde":"˜","diam":"⋄","diamond":"⋄","Diamond":"⋄","diamondsuit":"♦","diams":"♦","die":"¨","DifferentialD":"ⅆ","digamma":"ϝ","disin":"⋲","div":"÷","divide":"÷","divideontimes":"⋇","divonx":"⋇","DJcy":"Ђ","djcy":"ђ","dlcorn":"⌞","dlcrop":"⌍","dollar":"$","Dopf":"𝔻","dopf":"𝕕","Dot":"¨","dot":"˙","DotDot":"⃜","doteq":"≐","doteqdot":"≑","DotEqual":"≐","dotminus":"∸","dotplus":"∔","dotsquare":"⊡","doublebarwedge":"⌆","DoubleContourIntegral":"∯","DoubleDot":"¨","DoubleDownArrow":"⇓","DoubleLeftArrow":"⇐","DoubleLeftRightArrow":"⇔","DoubleLeftTee":"⫤","DoubleLongLeftArrow":"⟸","DoubleLongLeftRightArrow":"⟺","DoubleLongRightArrow":"⟹","DoubleRightArrow":"⇒","DoubleRightTee":"⊨","DoubleUpArrow":"⇑","DoubleUpDownArrow":"⇕","DoubleVerticalBar":"∥","DownArrowBar":"⤓","downarrow":"↓","DownArrow":"↓","Downarrow":"⇓","DownArrowUpArrow":"⇵","DownBreve":"̑","downdownarrows":"⇊","downharpoonleft":"⇃","downharpoonright":"⇂","DownLeftRightVector":"⥐","DownLeftTeeVector":"⥞","DownLeftVectorBar":"⥖","DownLeftVector":"↽","DownRightTeeVector":"⥟","DownRightVectorBar":"⥗","DownRightVector":"⇁","DownTeeArrow":"↧","DownTee":"⊤","drbkarow":"⤐","drcorn":"⌟","drcrop":"⌌","Dscr":"𝒟","dscr":"𝒹","DScy":"Ѕ","dscy":"ѕ","dsol":"⧶","Dstrok":"Đ","dstrok":"đ","dtdot":"⋱","dtri":"▿","dtrif":"▾","duarr":"⇵","duhar":"⥯","dwangle":"⦦","DZcy":"Џ","dzcy":"џ","dzigrarr":"⟿","Eacute":"É","eacute":"é","easter":"⩮","Ecaron":"Ě","ecaron":"ě","Ecirc":"Ê","ecirc":"ê","ecir":"≖","ecolon":"≕","Ecy":"Э","ecy":"э","eDDot":"⩷","Edot":"Ė","edot":"ė","eDot":"≑","ee":"ⅇ","efDot":"≒","Efr":"𝔈","efr":"𝔢","eg":"⪚","Egrave":"È","egrave":"è","egs":"⪖","egsdot":"⪘","el":"⪙","Element":"∈","elinters":"⏧","ell":"ℓ","els":"⪕","elsdot":"⪗","Emacr":"Ē","emacr":"ē","empty":"∅","emptyset":"∅","EmptySmallSquare":"◻","emptyv":"∅","EmptyVerySmallSquare":"▫","emsp13":" ","emsp14":" ","emsp":" ","ENG":"Ŋ","eng":"ŋ","ensp":" ","Eogon":"Ę","eogon":"ę","Eopf":"𝔼","eopf":"𝕖","epar":"⋕","eparsl":"⧣","eplus":"⩱","epsi":"ε","Epsilon":"Ε","epsilon":"ε","epsiv":"ϵ","eqcirc":"≖","eqcolon":"≕","eqsim":"≂","eqslantgtr":"⪖","eqslantless":"⪕","Equal":"⩵","equals":"=","EqualTilde":"≂","equest":"≟","Equilibrium":"⇌","equiv":"≡","equivDD":"⩸","eqvparsl":"⧥","erarr":"⥱","erDot":"≓","escr":"ℯ","Escr":"ℰ","esdot":"≐","Esim":"⩳","esim":"≂","Eta":"Η","eta":"η","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","euro":"€","excl":"!","exist":"∃","Exists":"∃","expectation":"ℰ","exponentiale":"ⅇ","ExponentialE":"ⅇ","fallingdotseq":"≒","Fcy":"Ф","fcy":"ф","female":"♀","ffilig":"ﬃ","fflig":"ﬀ","ffllig":"ﬄ","Ffr":"𝔉","ffr":"𝔣","filig":"ﬁ","FilledSmallSquare":"◼","FilledVerySmallSquare":"▪","fjlig":"fj","flat":"♭","fllig":"ﬂ","fltns":"▱","fnof":"ƒ","Fopf":"𝔽","fopf":"𝕗","forall":"∀","ForAll":"∀","fork":"⋔","forkv":"⫙","Fouriertrf":"ℱ","fpartint":"⨍","frac12":"½","frac13":"⅓","frac14":"¼","frac15":"⅕","frac16":"⅙","frac18":"⅛","frac23":"⅔","frac25":"⅖","frac34":"¾","frac35":"⅗","frac38":"⅜","frac45":"⅘","frac56":"⅚","frac58":"⅝","frac78":"⅞","frasl":"⁄","frown":"⌢","fscr":"𝒻","Fscr":"ℱ","gacute":"ǵ","Gamma":"Γ","gamma":"γ","Gammad":"Ϝ","gammad":"ϝ","gap":"⪆","Gbreve":"Ğ","gbreve":"ğ","Gcedil":"Ģ","Gcirc":"Ĝ","gcirc":"ĝ","Gcy":"Г","gcy":"г","Gdot":"Ġ","gdot":"ġ","ge":"≥","gE":"≧","gEl":"⪌","gel":"⋛","geq":"≥","geqq":"≧","geqslant":"⩾","gescc":"⪩","ges":"⩾","gesdot":"⪀","gesdoto":"⪂","gesdotol":"⪄","gesl":"⋛︀","gesles":"⪔","Gfr":"𝔊","gfr":"𝔤","gg":"≫","Gg":"⋙","ggg":"⋙","gimel":"ℷ","GJcy":"Ѓ","gjcy":"ѓ","gla":"⪥","gl":"≷","glE":"⪒","glj":"⪤","gnap":"⪊","gnapprox":"⪊","gne":"⪈","gnE":"≩","gneq":"⪈","gneqq":"≩","gnsim":"⋧","Gopf":"𝔾","gopf":"𝕘","grave":"`","GreaterEqual":"≥","GreaterEqualLess":"⋛","GreaterFullEqual":"≧","GreaterGreater":"⪢","GreaterLess":"≷","GreaterSlantEqual":"⩾","GreaterTilde":"≳","Gscr":"𝒢","gscr":"ℊ","gsim":"≳","gsime":"⪎","gsiml":"⪐","gtcc":"⪧","gtcir":"⩺","gt":">","GT":">","Gt":"≫","gtdot":"⋗","gtlPar":"⦕","gtquest":"⩼","gtrapprox":"⪆","gtrarr":"⥸","gtrdot":"⋗","gtreqless":"⋛","gtreqqless":"⪌","gtrless":"≷","gtrsim":"≳","gvertneqq":"≩︀","gvnE":"≩︀","Hacek":"ˇ","hairsp":" ","half":"½","hamilt":"ℋ","HARDcy":"Ъ","hardcy":"ъ","harrcir":"⥈","harr":"↔","hArr":"⇔","harrw":"↭","Hat":"^","hbar":"ℏ","Hcirc":"Ĥ","hcirc":"ĥ","hearts":"♥","heartsuit":"♥","hellip":"…","hercon":"⊹","hfr":"𝔥","Hfr":"ℌ","HilbertSpace":"ℋ","hksearow":"⤥","hkswarow":"⤦","hoarr":"⇿","homtht":"∻","hookleftarrow":"↩","hookrightarrow":"↪","hopf":"𝕙","Hopf":"ℍ","horbar":"―","HorizontalLine":"─","hscr":"𝒽","Hscr":"ℋ","hslash":"ℏ","Hstrok":"Ħ","hstrok":"ħ","HumpDownHump":"≎","HumpEqual":"≏","hybull":"⁃","hyphen":"‐","Iacute":"Í","iacute":"í","ic":"⁣","Icirc":"Î","icirc":"î","Icy":"И","icy":"и","Idot":"İ","IEcy":"Е","iecy":"е","iexcl":"¡","iff":"⇔","ifr":"𝔦","Ifr":"ℑ","Igrave":"Ì","igrave":"ì","ii":"ⅈ","iiiint":"⨌","iiint":"∭","iinfin":"⧜","iiota":"℩","IJlig":"Ĳ","ijlig":"ĳ","Imacr":"Ī","imacr":"ī","image":"ℑ","ImaginaryI":"ⅈ","imagline":"ℐ","imagpart":"ℑ","imath":"ı","Im":"ℑ","imof":"⊷","imped":"Ƶ","Implies":"⇒","incare":"℅","in":"∈","infin":"∞","infintie":"⧝","inodot":"ı","intcal":"⊺","int":"∫","Int":"∬","integers":"ℤ","Integral":"∫","intercal":"⊺","Intersection":"⋂","intlarhk":"⨗","intprod":"⨼","InvisibleComma":"⁣","InvisibleTimes":"⁢","IOcy":"Ё","iocy":"ё","Iogon":"Į","iogon":"į","Iopf":"𝕀","iopf":"𝕚","Iota":"Ι","iota":"ι","iprod":"⨼","iquest":"¿","iscr":"𝒾","Iscr":"ℐ","isin":"∈","isindot":"⋵","isinE":"⋹","isins":"⋴","isinsv":"⋳","isinv":"∈","it":"⁢","Itilde":"Ĩ","itilde":"ĩ","Iukcy":"І","iukcy":"і","Iuml":"Ï","iuml":"ï","Jcirc":"Ĵ","jcirc":"ĵ","Jcy":"Й","jcy":"й","Jfr":"𝔍","jfr":"𝔧","jmath":"ȷ","Jopf":"𝕁","jopf":"𝕛","Jscr":"𝒥","jscr":"𝒿","Jsercy":"Ј","jsercy":"ј","Jukcy":"Є","jukcy":"є","Kappa":"Κ","kappa":"κ","kappav":"ϰ","Kcedil":"Ķ","kcedil":"ķ","Kcy":"К","kcy":"к","Kfr":"𝔎","kfr":"𝔨","kgreen":"ĸ","KHcy":"Х","khcy":"х","KJcy":"Ќ","kjcy":"ќ","Kopf":"𝕂","kopf":"𝕜","Kscr":"𝒦","kscr":"𝓀","lAarr":"⇚","Lacute":"Ĺ","lacute":"ĺ","laemptyv":"⦴","lagran":"ℒ","Lambda":"Λ","lambda":"λ","lang":"⟨","Lang":"⟪","langd":"⦑","langle":"⟨","lap":"⪅","Laplacetrf":"ℒ","laquo":"«","larrb":"⇤","larrbfs":"⤟","larr":"←","Larr":"↞","lArr":"⇐","larrfs":"⤝","larrhk":"↩","larrlp":"↫","larrpl":"⤹","larrsim":"⥳","larrtl":"↢","latail":"⤙","lAtail":"⤛","lat":"⪫","late":"⪭","lates":"⪭︀","lbarr":"⤌","lBarr":"⤎","lbbrk":"❲","lbrace":"{","lbrack":"[","lbrke":"⦋","lbrksld":"⦏","lbrkslu":"⦍","Lcaron":"Ľ","lcaron":"ľ","Lcedil":"Ļ","lcedil":"ļ","lceil":"⌈","lcub":"{","Lcy":"Л","lcy":"л","ldca":"⤶","ldquo":"“","ldquor":"„","ldrdhar":"⥧","ldrushar":"⥋","ldsh":"↲","le":"≤","lE":"≦","LeftAngleBracket":"⟨","LeftArrowBar":"⇤","leftarrow":"←","LeftArrow":"←","Leftarrow":"⇐","LeftArrowRightArrow":"⇆","leftarrowtail":"↢","LeftCeiling":"⌈","LeftDoubleBracket":"⟦","LeftDownTeeVector":"⥡","LeftDownVectorBar":"⥙","LeftDownVector":"⇃","LeftFloor":"⌊","leftharpoondown":"↽","leftharpoonup":"↼","leftleftarrows":"⇇","leftrightarrow":"↔","LeftRightArrow":"↔","Leftrightarrow":"⇔","leftrightarrows":"⇆","leftrightharpoons":"⇋","leftrightsquigarrow":"↭","LeftRightVector":"⥎","LeftTeeArrow":"↤","LeftTee":"⊣","LeftTeeVector":"⥚","leftthreetimes":"⋋","LeftTriangleBar":"⧏","LeftTriangle":"⊲","LeftTriangleEqual":"⊴","LeftUpDownVector":"⥑","LeftUpTeeVector":"⥠","LeftUpVectorBar":"⥘","LeftUpVector":"↿","LeftVectorBar":"⥒","LeftVector":"↼","lEg":"⪋","leg":"⋚","leq":"≤","leqq":"≦","leqslant":"⩽","lescc":"⪨","les":"⩽","lesdot":"⩿","lesdoto":"⪁","lesdotor":"⪃","lesg":"⋚︀","lesges":"⪓","lessapprox":"⪅","lessdot":"⋖","lesseqgtr":"⋚","lesseqqgtr":"⪋","LessEqualGreater":"⋚","LessFullEqual":"≦","LessGreater":"≶","lessgtr":"≶","LessLess":"⪡","lesssim":"≲","LessSlantEqual":"⩽","LessTilde":"≲","lfisht":"⥼","lfloor":"⌊","Lfr":"𝔏","lfr":"𝔩","lg":"≶","lgE":"⪑","lHar":"⥢","lhard":"↽","lharu":"↼","lharul":"⥪","lhblk":"▄","LJcy":"Љ","ljcy":"љ","llarr":"⇇","ll":"≪","Ll":"⋘","llcorner":"⌞","Lleftarrow":"⇚","llhard":"⥫","lltri":"◺","Lmidot":"Ŀ","lmidot":"ŀ","lmoustache":"⎰","lmoust":"⎰","lnap":"⪉","lnapprox":"⪉","lne":"⪇","lnE":"≨","lneq":"⪇","lneqq":"≨","lnsim":"⋦","loang":"⟬","loarr":"⇽","lobrk":"⟦","longleftarrow":"⟵","LongLeftArrow":"⟵","Longleftarrow":"⟸","longleftrightarrow":"⟷","LongLeftRightArrow":"⟷","Longleftrightarrow":"⟺","longmapsto":"⟼","longrightarrow":"⟶","LongRightArrow":"⟶","Longrightarrow":"⟹","looparrowleft":"↫","looparrowright":"↬","lopar":"⦅","Lopf":"𝕃","lopf":"𝕝","loplus":"⨭","lotimes":"⨴","lowast":"∗","lowbar":"_","LowerLeftArrow":"↙","LowerRightArrow":"↘","loz":"◊","lozenge":"◊","lozf":"⧫","lpar":"(","lparlt":"⦓","lrarr":"⇆","lrcorner":"⌟","lrhar":"⇋","lrhard":"⥭","lrm":"‎","lrtri":"⊿","lsaquo":"‹","lscr":"𝓁","Lscr":"ℒ","lsh":"↰","Lsh":"↰","lsim":"≲","lsime":"⪍","lsimg":"⪏","lsqb":"[","lsquo":"‘","lsquor":"‚","Lstrok":"Ł","lstrok":"ł","ltcc":"⪦","ltcir":"⩹","lt":"<","LT":"<","Lt":"≪","ltdot":"⋖","lthree":"⋋","ltimes":"⋉","ltlarr":"⥶","ltquest":"⩻","ltri":"◃","ltrie":"⊴","ltrif":"◂","ltrPar":"⦖","lurdshar":"⥊","luruhar":"⥦","lvertneqq":"≨︀","lvnE":"≨︀","macr":"¯","male":"♂","malt":"✠","maltese":"✠","Map":"⤅","map":"↦","mapsto":"↦","mapstodown":"↧","mapstoleft":"↤","mapstoup":"↥","marker":"▮","mcomma":"⨩","Mcy":"М","mcy":"м","mdash":"—","mDDot":"∺","measuredangle":"∡","MediumSpace":" ","Mellintrf":"ℳ","Mfr":"𝔐","mfr":"𝔪","mho":"℧","micro":"µ","midast":"*","midcir":"⫰","mid":"∣","middot":"·","minusb":"⊟","minus":"−","minusd":"∸","minusdu":"⨪","MinusPlus":"∓","mlcp":"⫛","mldr":"…","mnplus":"∓","models":"⊧","Mopf":"𝕄","mopf":"𝕞","mp":"∓","mscr":"𝓂","Mscr":"ℳ","mstpos":"∾","Mu":"Μ","mu":"μ","multimap":"⊸","mumap":"⊸","nabla":"∇","Nacute":"Ń","nacute":"ń","nang":"∠⃒","nap":"≉","napE":"⩰̸","napid":"≋̸","napos":"ŉ","napprox":"≉","natural":"♮","naturals":"ℕ","natur":"♮","nbsp":" ","nbump":"≎̸","nbumpe":"≏̸","ncap":"⩃","Ncaron":"Ň","ncaron":"ň","Ncedil":"Ņ","ncedil":"ņ","ncong":"≇","ncongdot":"⩭̸","ncup":"⩂","Ncy":"Н","ncy":"н","ndash":"–","nearhk":"⤤","nearr":"↗","neArr":"⇗","nearrow":"↗","ne":"≠","nedot":"≐̸","NegativeMediumSpace":"​","NegativeThickSpace":"​","NegativeThinSpace":"​","NegativeVeryThinSpace":"​","nequiv":"≢","nesear":"⤨","nesim":"≂̸","NestedGreaterGreater":"≫","NestedLessLess":"≪","NewLine":"\n","nexist":"∄","nexists":"∄","Nfr":"𝔑","nfr":"𝔫","ngE":"≧̸","nge":"≱","ngeq":"≱","ngeqq":"≧̸","ngeqslant":"⩾̸","nges":"⩾̸","nGg":"⋙̸","ngsim":"≵","nGt":"≫⃒","ngt":"≯","ngtr":"≯","nGtv":"≫̸","nharr":"↮","nhArr":"⇎","nhpar":"⫲","ni":"∋","nis":"⋼","nisd":"⋺","niv":"∋","NJcy":"Њ","njcy":"њ","nlarr":"↚","nlArr":"⇍","nldr":"‥","nlE":"≦̸","nle":"≰","nleftarrow":"↚","nLeftarrow":"⇍","nleftrightarrow":"↮","nLeftrightarrow":"⇎","nleq":"≰","nleqq":"≦̸","nleqslant":"⩽̸","nles":"⩽̸","nless":"≮","nLl":"⋘̸","nlsim":"≴","nLt":"≪⃒","nlt":"≮","nltri":"⋪","nltrie":"⋬","nLtv":"≪̸","nmid":"∤","NoBreak":"⁠","NonBreakingSpace":" ","nopf":"𝕟","Nopf":"ℕ","Not":"⫬","not":"¬","NotCongruent":"≢","NotCupCap":"≭","NotDoubleVerticalBar":"∦","NotElement":"∉","NotEqual":"≠","NotEqualTilde":"≂̸","NotExists":"∄","NotGreater":"≯","NotGreaterEqual":"≱","NotGreaterFullEqual":"≧̸","NotGreaterGreater":"≫̸","NotGreaterLess":"≹","NotGreaterSlantEqual":"⩾̸","NotGreaterTilde":"≵","NotHumpDownHump":"≎̸","NotHumpEqual":"≏̸","notin":"∉","notindot":"⋵̸","notinE":"⋹̸","notinva":"∉","notinvb":"⋷","notinvc":"⋶","NotLeftTriangleBar":"⧏̸","NotLeftTriangle":"⋪","NotLeftTriangleEqual":"⋬","NotLess":"≮","NotLessEqual":"≰","NotLessGreater":"≸","NotLessLess":"≪̸","NotLessSlantEqual":"⩽̸","NotLessTilde":"≴","NotNestedGreaterGreater":"⪢̸","NotNestedLessLess":"⪡̸","notni":"∌","notniva":"∌","notnivb":"⋾","notnivc":"⋽","NotPrecedes":"⊀","NotPrecedesEqual":"⪯̸","NotPrecedesSlantEqual":"⋠","NotReverseElement":"∌","NotRightTriangleBar":"⧐̸","NotRightTriangle":"⋫","NotRightTriangleEqual":"⋭","NotSquareSubset":"⊏̸","NotSquareSubsetEqual":"⋢","NotSquareSuperset":"⊐̸","NotSquareSupersetEqual":"⋣","NotSubset":"⊂⃒","NotSubsetEqual":"⊈","NotSucceeds":"⊁","NotSucceedsEqual":"⪰̸","NotSucceedsSlantEqual":"⋡","NotSucceedsTilde":"≿̸","NotSuperset":"⊃⃒","NotSupersetEqual":"⊉","NotTilde":"≁","NotTildeEqual":"≄","NotTildeFullEqual":"≇","NotTildeTilde":"≉","NotVerticalBar":"∤","nparallel":"∦","npar":"∦","nparsl":"⫽⃥","npart":"∂̸","npolint":"⨔","npr":"⊀","nprcue":"⋠","nprec":"⊀","npreceq":"⪯̸","npre":"⪯̸","nrarrc":"⤳̸","nrarr":"↛","nrArr":"⇏","nrarrw":"↝̸","nrightarrow":"↛","nRightarrow":"⇏","nrtri":"⋫","nrtrie":"⋭","nsc":"⊁","nsccue":"⋡","nsce":"⪰̸","Nscr":"𝒩","nscr":"𝓃","nshortmid":"∤","nshortparallel":"∦","nsim":"≁","nsime":"≄","nsimeq":"≄","nsmid":"∤","nspar":"∦","nsqsube":"⋢","nsqsupe":"⋣","nsub":"⊄","nsubE":"⫅̸","nsube":"⊈","nsubset":"⊂⃒","nsubseteq":"⊈","nsubseteqq":"⫅̸","nsucc":"⊁","nsucceq":"⪰̸","nsup":"⊅","nsupE":"⫆̸","nsupe":"⊉","nsupset":"⊃⃒","nsupseteq":"⊉","nsupseteqq":"⫆̸","ntgl":"≹","Ntilde":"Ñ","ntilde":"ñ","ntlg":"≸","ntriangleleft":"⋪","ntrianglelefteq":"⋬","ntriangleright":"⋫","ntrianglerighteq":"⋭","Nu":"Ν","nu":"ν","num":"#","numero":"№","numsp":" ","nvap":"≍⃒","nvdash":"⊬","nvDash":"⊭","nVdash":"⊮","nVDash":"⊯","nvge":"≥⃒","nvgt":">⃒","nvHarr":"⤄","nvinfin":"⧞","nvlArr":"⤂","nvle":"≤⃒","nvlt":"<⃒","nvltrie":"⊴⃒","nvrArr":"⤃","nvrtrie":"⊵⃒","nvsim":"∼⃒","nwarhk":"⤣","nwarr":"↖","nwArr":"⇖","nwarrow":"↖","nwnear":"⤧","Oacute":"Ó","oacute":"ó","oast":"⊛","Ocirc":"Ô","ocirc":"ô","ocir":"⊚","Ocy":"О","ocy":"о","odash":"⊝","Odblac":"Ő","odblac":"ő","odiv":"⨸","odot":"⊙","odsold":"⦼","OElig":"Œ","oelig":"œ","ofcir":"⦿","Ofr":"𝔒","ofr":"𝔬","ogon":"˛","Ograve":"Ò","ograve":"ò","ogt":"⧁","ohbar":"⦵","ohm":"Ω","oint":"∮","olarr":"↺","olcir":"⦾","olcross":"⦻","oline":"‾","olt":"⧀","Omacr":"Ō","omacr":"ō","Omega":"Ω","omega":"ω","Omicron":"Ο","omicron":"ο","omid":"⦶","ominus":"⊖","Oopf":"𝕆","oopf":"𝕠","opar":"⦷","OpenCurlyDoubleQuote":"“","OpenCurlyQuote":"‘","operp":"⦹","oplus":"⊕","orarr":"↻","Or":"⩔","or":"∨","ord":"⩝","order":"ℴ","orderof":"ℴ","ordf":"ª","ordm":"º","origof":"⊶","oror":"⩖","orslope":"⩗","orv":"⩛","oS":"Ⓢ","Oscr":"𝒪","oscr":"ℴ","Oslash":"Ø","oslash":"ø","osol":"⊘","Otilde":"Õ","otilde":"õ","otimesas":"⨶","Otimes":"⨷","otimes":"⊗","Ouml":"Ö","ouml":"ö","ovbar":"⌽","OverBar":"‾","OverBrace":"⏞","OverBracket":"⎴","OverParenthesis":"⏜","para":"¶","parallel":"∥","par":"∥","parsim":"⫳","parsl":"⫽","part":"∂","PartialD":"∂","Pcy":"П","pcy":"п","percnt":"%","period":".","permil":"‰","perp":"⊥","pertenk":"‱","Pfr":"𝔓","pfr":"𝔭","Phi":"Φ","phi":"φ","phiv":"ϕ","phmmat":"ℳ","phone":"☎","Pi":"Π","pi":"π","pitchfork":"⋔","piv":"ϖ","planck":"ℏ","planckh":"ℎ","plankv":"ℏ","plusacir":"⨣","plusb":"⊞","pluscir":"⨢","plus":"+","plusdo":"∔","plusdu":"⨥","pluse":"⩲","PlusMinus":"±","plusmn":"±","plussim":"⨦","plustwo":"⨧","pm":"±","Poincareplane":"ℌ","pointint":"⨕","popf":"𝕡","Popf":"ℙ","pound":"£","prap":"⪷","Pr":"⪻","pr":"≺","prcue":"≼","precapprox":"⪷","prec":"≺","preccurlyeq":"≼","Precedes":"≺","PrecedesEqual":"⪯","PrecedesSlantEqual":"≼","PrecedesTilde":"≾","preceq":"⪯","precnapprox":"⪹","precneqq":"⪵","precnsim":"⋨","pre":"⪯","prE":"⪳","precsim":"≾","prime":"′","Prime":"″","primes":"ℙ","prnap":"⪹","prnE":"⪵","prnsim":"⋨","prod":"∏","Product":"∏","profalar":"⌮","profline":"⌒","profsurf":"⌓","prop":"∝","Proportional":"∝","Proportion":"∷","propto":"∝","prsim":"≾","prurel":"⊰","Pscr":"𝒫","pscr":"𝓅","Psi":"Ψ","psi":"ψ","puncsp":" ","Qfr":"𝔔","qfr":"𝔮","qint":"⨌","qopf":"𝕢","Qopf":"ℚ","qprime":"⁗","Qscr":"𝒬","qscr":"𝓆","quaternions":"ℍ","quatint":"⨖","quest":"?","questeq":"≟","quot":"\"","QUOT":"\"","rAarr":"⇛","race":"∽̱","Racute":"Ŕ","racute":"ŕ","radic":"√","raemptyv":"⦳","rang":"⟩","Rang":"⟫","rangd":"⦒","range":"⦥","rangle":"⟩","raquo":"»","rarrap":"⥵","rarrb":"⇥","rarrbfs":"⤠","rarrc":"⤳","rarr":"→","Rarr":"↠","rArr":"⇒","rarrfs":"⤞","rarrhk":"↪","rarrlp":"↬","rarrpl":"⥅","rarrsim":"⥴","Rarrtl":"⤖","rarrtl":"↣","rarrw":"↝","ratail":"⤚","rAtail":"⤜","ratio":"∶","rationals":"ℚ","rbarr":"⤍","rBarr":"⤏","RBarr":"⤐","rbbrk":"❳","rbrace":"}","rbrack":"]","rbrke":"⦌","rbrksld":"⦎","rbrkslu":"⦐","Rcaron":"Ř","rcaron":"ř","Rcedil":"Ŗ","rcedil":"ŗ","rceil":"⌉","rcub":"}","Rcy":"Р","rcy":"р","rdca":"⤷","rdldhar":"⥩","rdquo":"”","rdquor":"”","rdsh":"↳","real":"ℜ","realine":"ℛ","realpart":"ℜ","reals":"ℝ","Re":"ℜ","rect":"▭","reg":"®","REG":"®","ReverseElement":"∋","ReverseEquilibrium":"⇋","ReverseUpEquilibrium":"⥯","rfisht":"⥽","rfloor":"⌋","rfr":"𝔯","Rfr":"ℜ","rHar":"⥤","rhard":"⇁","rharu":"⇀","rharul":"⥬","Rho":"Ρ","rho":"ρ","rhov":"ϱ","RightAngleBracket":"⟩","RightArrowBar":"⇥","rightarrow":"→","RightArrow":"→","Rightarrow":"⇒","RightArrowLeftArrow":"⇄","rightarrowtail":"↣","RightCeiling":"⌉","RightDoubleBracket":"⟧","RightDownTeeVector":"⥝","RightDownVectorBar":"⥕","RightDownVector":"⇂","RightFloor":"⌋","rightharpoondown":"⇁","rightharpoonup":"⇀","rightleftarrows":"⇄","rightleftharpoons":"⇌","rightrightarrows":"⇉","rightsquigarrow":"↝","RightTeeArrow":"↦","RightTee":"⊢","RightTeeVector":"⥛","rightthreetimes":"⋌","RightTriangleBar":"⧐","RightTriangle":"⊳","RightTriangleEqual":"⊵","RightUpDownVector":"⥏","RightUpTeeVector":"⥜","RightUpVectorBar":"⥔","RightUpVector":"↾","RightVectorBar":"⥓","RightVector":"⇀","ring":"˚","risingdotseq":"≓","rlarr":"⇄","rlhar":"⇌","rlm":"‏","rmoustache":"⎱","rmoust":"⎱","rnmid":"⫮","roang":"⟭","roarr":"⇾","robrk":"⟧","ropar":"⦆","ropf":"𝕣","Ropf":"ℝ","roplus":"⨮","rotimes":"⨵","RoundImplies":"⥰","rpar":")","rpargt":"⦔","rppolint":"⨒","rrarr":"⇉","Rrightarrow":"⇛","rsaquo":"›","rscr":"𝓇","Rscr":"ℛ","rsh":"↱","Rsh":"↱","rsqb":"]","rsquo":"’","rsquor":"’","rthree":"⋌","rtimes":"⋊","rtri":"▹","rtrie":"⊵","rtrif":"▸","rtriltri":"⧎","RuleDelayed":"⧴","ruluhar":"⥨","rx":"℞","Sacute":"Ś","sacute":"ś","sbquo":"‚","scap":"⪸","Scaron":"Š","scaron":"š","Sc":"⪼","sc":"≻","sccue":"≽","sce":"⪰","scE":"⪴","Scedil":"Ş","scedil":"ş","Scirc":"Ŝ","scirc":"ŝ","scnap":"⪺","scnE":"⪶","scnsim":"⋩","scpolint":"⨓","scsim":"≿","Scy":"С","scy":"с","sdotb":"⊡","sdot":"⋅","sdote":"⩦","searhk":"⤥","searr":"↘","seArr":"⇘","searrow":"↘","sect":"§","semi":";","seswar":"⤩","setminus":"∖","setmn":"∖","sext":"✶","Sfr":"𝔖","sfr":"𝔰","sfrown":"⌢","sharp":"♯","SHCHcy":"Щ","shchcy":"щ","SHcy":"Ш","shcy":"ш","ShortDownArrow":"↓","ShortLeftArrow":"←","shortmid":"∣","shortparallel":"∥","ShortRightArrow":"→","ShortUpArrow":"↑","shy":"­","Sigma":"Σ","sigma":"σ","sigmaf":"ς","sigmav":"ς","sim":"∼","simdot":"⩪","sime":"≃","simeq":"≃","simg":"⪞","simgE":"⪠","siml":"⪝","simlE":"⪟","simne":"≆","simplus":"⨤","simrarr":"⥲","slarr":"←","SmallCircle":"∘","smallsetminus":"∖","smashp":"⨳","smeparsl":"⧤","smid":"∣","smile":"⌣","smt":"⪪","smte":"⪬","smtes":"⪬︀","SOFTcy":"Ь","softcy":"ь","solbar":"⌿","solb":"⧄","sol":"/","Sopf":"𝕊","sopf":"𝕤","spades":"♠","spadesuit":"♠","spar":"∥","sqcap":"⊓","sqcaps":"⊓︀","sqcup":"⊔","sqcups":"⊔︀","Sqrt":"√","sqsub":"⊏","sqsube":"⊑","sqsubset":"⊏","sqsubseteq":"⊑","sqsup":"⊐","sqsupe":"⊒","sqsupset":"⊐","sqsupseteq":"⊒","square":"□","Square":"□","SquareIntersection":"⊓","SquareSubset":"⊏","SquareSubsetEqual":"⊑","SquareSuperset":"⊐","SquareSupersetEqual":"⊒","SquareUnion":"⊔","squarf":"▪","squ":"□","squf":"▪","srarr":"→","Sscr":"𝒮","sscr":"𝓈","ssetmn":"∖","ssmile":"⌣","sstarf":"⋆","Star":"⋆","star":"☆","starf":"★","straightepsilon":"ϵ","straightphi":"ϕ","strns":"¯","sub":"⊂","Sub":"⋐","subdot":"⪽","subE":"⫅","sube":"⊆","subedot":"⫃","submult":"⫁","subnE":"⫋","subne":"⊊","subplus":"⪿","subrarr":"⥹","subset":"⊂","Subset":"⋐","subseteq":"⊆","subseteqq":"⫅","SubsetEqual":"⊆","subsetneq":"⊊","subsetneqq":"⫋","subsim":"⫇","subsub":"⫕","subsup":"⫓","succapprox":"⪸","succ":"≻","succcurlyeq":"≽","Succeeds":"≻","SucceedsEqual":"⪰","SucceedsSlantEqual":"≽","SucceedsTilde":"≿","succeq":"⪰","succnapprox":"⪺","succneqq":"⪶","succnsim":"⋩","succsim":"≿","SuchThat":"∋","sum":"∑","Sum":"∑","sung":"♪","sup1":"¹","sup2":"²","sup3":"³","sup":"⊃","Sup":"⋑","supdot":"⪾","supdsub":"⫘","supE":"⫆","supe":"⊇","supedot":"⫄","Superset":"⊃","SupersetEqual":"⊇","suphsol":"⟉","suphsub":"⫗","suplarr":"⥻","supmult":"⫂","supnE":"⫌","supne":"⊋","supplus":"⫀","supset":"⊃","Supset":"⋑","supseteq":"⊇","supseteqq":"⫆","supsetneq":"⊋","supsetneqq":"⫌","supsim":"⫈","supsub":"⫔","supsup":"⫖","swarhk":"⤦","swarr":"↙","swArr":"⇙","swarrow":"↙","swnwar":"⤪","szlig":"ß","Tab":"\t","target":"⌖","Tau":"Τ","tau":"τ","tbrk":"⎴","Tcaron":"Ť","tcaron":"ť","Tcedil":"Ţ","tcedil":"ţ","Tcy":"Т","tcy":"т","tdot":"⃛","telrec":"⌕","Tfr":"𝔗","tfr":"𝔱","there4":"∴","therefore":"∴","Therefore":"∴","Theta":"Θ","theta":"θ","thetasym":"ϑ","thetav":"ϑ","thickapprox":"≈","thicksim":"∼","ThickSpace":"  ","ThinSpace":" ","thinsp":" ","thkap":"≈","thksim":"∼","THORN":"Þ","thorn":"þ","tilde":"˜","Tilde":"∼","TildeEqual":"≃","TildeFullEqual":"≅","TildeTilde":"≈","timesbar":"⨱","timesb":"⊠","times":"×","timesd":"⨰","tint":"∭","toea":"⤨","topbot":"⌶","topcir":"⫱","top":"⊤","Topf":"𝕋","topf":"𝕥","topfork":"⫚","tosa":"⤩","tprime":"‴","trade":"™","TRADE":"™","triangle":"▵","triangledown":"▿","triangleleft":"◃","trianglelefteq":"⊴","triangleq":"≜","triangleright":"▹","trianglerighteq":"⊵","tridot":"◬","trie":"≜","triminus":"⨺","TripleDot":"⃛","triplus":"⨹","trisb":"⧍","tritime":"⨻","trpezium":"⏢","Tscr":"𝒯","tscr":"𝓉","TScy":"Ц","tscy":"ц","TSHcy":"Ћ","tshcy":"ћ","Tstrok":"Ŧ","tstrok":"ŧ","twixt":"≬","twoheadleftarrow":"↞","twoheadrightarrow":"↠","Uacute":"Ú","uacute":"ú","uarr":"↑","Uarr":"↟","uArr":"⇑","Uarrocir":"⥉","Ubrcy":"Ў","ubrcy":"ў","Ubreve":"Ŭ","ubreve":"ŭ","Ucirc":"Û","ucirc":"û","Ucy":"У","ucy":"у","udarr":"⇅","Udblac":"Ű","udblac":"ű","udhar":"⥮","ufisht":"⥾","Ufr":"𝔘","ufr":"𝔲","Ugrave":"Ù","ugrave":"ù","uHar":"⥣","uharl":"↿","uharr":"↾","uhblk":"▀","ulcorn":"⌜","ulcorner":"⌜","ulcrop":"⌏","ultri":"◸","Umacr":"Ū","umacr":"ū","uml":"¨","UnderBar":"_","UnderBrace":"⏟","UnderBracket":"⎵","UnderParenthesis":"⏝","Union":"⋃","UnionPlus":"⊎","Uogon":"Ų","uogon":"ų","Uopf":"𝕌","uopf":"𝕦","UpArrowBar":"⤒","uparrow":"↑","UpArrow":"↑","Uparrow":"⇑","UpArrowDownArrow":"⇅","updownarrow":"↕","UpDownArrow":"↕","Updownarrow":"⇕","UpEquilibrium":"⥮","upharpoonleft":"↿","upharpoonright":"↾","uplus":"⊎","UpperLeftArrow":"↖","UpperRightArrow":"↗","upsi":"υ","Upsi":"ϒ","upsih":"ϒ","Upsilon":"Υ","upsilon":"υ","UpTeeArrow":"↥","UpTee":"⊥","upuparrows":"⇈","urcorn":"⌝","urcorner":"⌝","urcrop":"⌎","Uring":"Ů","uring":"ů","urtri":"◹","Uscr":"𝒰","uscr":"𝓊","utdot":"⋰","Utilde":"Ũ","utilde":"ũ","utri":"▵","utrif":"▴","uuarr":"⇈","Uuml":"Ü","uuml":"ü","uwangle":"⦧","vangrt":"⦜","varepsilon":"ϵ","varkappa":"ϰ","varnothing":"∅","varphi":"ϕ","varpi":"ϖ","varpropto":"∝","varr":"↕","vArr":"⇕","varrho":"ϱ","varsigma":"ς","varsubsetneq":"⊊︀","varsubsetneqq":"⫋︀","varsupsetneq":"⊋︀","varsupsetneqq":"⫌︀","vartheta":"ϑ","vartriangleleft":"⊲","vartriangleright":"⊳","vBar":"⫨","Vbar":"⫫","vBarv":"⫩","Vcy":"В","vcy":"в","vdash":"⊢","vDash":"⊨","Vdash":"⊩","VDash":"⊫","Vdashl":"⫦","veebar":"⊻","vee":"∨","Vee":"⋁","veeeq":"≚","vellip":"⋮","verbar":"|","Verbar":"‖","vert":"|","Vert":"‖","VerticalBar":"∣","VerticalLine":"|","VerticalSeparator":"❘","VerticalTilde":"≀","VeryThinSpace":" ","Vfr":"𝔙","vfr":"𝔳","vltri":"⊲","vnsub":"⊂⃒","vnsup":"⊃⃒","Vopf":"𝕍","vopf":"𝕧","vprop":"∝","vrtri":"⊳","Vscr":"𝒱","vscr":"𝓋","vsubnE":"⫋︀","vsubne":"⊊︀","vsupnE":"⫌︀","vsupne":"⊋︀","Vvdash":"⊪","vzigzag":"⦚","Wcirc":"Ŵ","wcirc":"ŵ","wedbar":"⩟","wedge":"∧","Wedge":"⋀","wedgeq":"≙","weierp":"℘","Wfr":"𝔚","wfr":"𝔴","Wopf":"𝕎","wopf":"𝕨","wp":"℘","wr":"≀","wreath":"≀","Wscr":"𝒲","wscr":"𝓌","xcap":"⋂","xcirc":"◯","xcup":"⋃","xdtri":"▽","Xfr":"𝔛","xfr":"𝔵","xharr":"⟷","xhArr":"⟺","Xi":"Ξ","xi":"ξ","xlarr":"⟵","xlArr":"⟸","xmap":"⟼","xnis":"⋻","xodot":"⨀","Xopf":"𝕏","xopf":"𝕩","xoplus":"⨁","xotime":"⨂","xrarr":"⟶","xrArr":"⟹","Xscr":"𝒳","xscr":"𝓍","xsqcup":"⨆","xuplus":"⨄","xutri":"△","xvee":"⋁","xwedge":"⋀","Yacute":"Ý","yacute":"ý","YAcy":"Я","yacy":"я","Ycirc":"Ŷ","ycirc":"ŷ","Ycy":"Ы","ycy":"ы","yen":"¥","Yfr":"𝔜","yfr":"𝔶","YIcy":"Ї","yicy":"ї","Yopf":"𝕐","yopf":"𝕪","Yscr":"𝒴","yscr":"𝓎","YUcy":"Ю","yucy":"ю","yuml":"ÿ","Yuml":"Ÿ","Zacute":"Ź","zacute":"ź","Zcaron":"Ž","zcaron":"ž","Zcy":"З","zcy":"з","Zdot":"Ż","zdot":"ż","zeetrf":"ℨ","ZeroWidthSpace":"​","Zeta":"Ζ","zeta":"ζ","zfr":"𝔷","Zfr":"ℨ","ZHcy":"Ж","zhcy":"ж","zigrarr":"⇝","zopf":"𝕫","Zopf":"ℤ","Zscr":"𝒵","zscr":"𝓏","zwj":"‍","zwnj":"‌"}

/***/ }),
/* 242 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(144),
  /* template */
  __webpack_require__(394),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(145),
  /* template */
  __webpack_require__(403),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(146),
  /* template */
  __webpack_require__(411),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(147),
  /* template */
  __webpack_require__(386),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(149),
  /* template */
  __webpack_require__(406),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(150),
  /* template */
  __webpack_require__(392),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(153),
  /* template */
  __webpack_require__(409),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(154),
  /* template */
  __webpack_require__(387),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(155),
  /* template */
  __webpack_require__(408),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(156),
  /* template */
  __webpack_require__(393),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(157),
  /* template */
  __webpack_require__(388),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(158),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(159),
  /* template */
  __webpack_require__(405),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(161),
  /* template */
  __webpack_require__(402),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(162),
  /* template */
  __webpack_require__(401),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(163),
  /* template */
  __webpack_require__(391),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(164),
  /* template */
  __webpack_require__(407),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(165),
  /* template */
  __webpack_require__(390),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(166),
  /* template */
  __webpack_require__(396),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(167),
  /* template */
  __webpack_require__(395),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(168),
  /* template */
  __webpack_require__(410),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(169),
  /* template */
  __webpack_require__(399),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(170),
  /* template */
  __webpack_require__(389),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(171),
  /* template */
  __webpack_require__(398),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 384 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    attrs: {
      "id": "home-page"
    }
  }, [(!_vm.shouldShowLandingPage && !_vm.failedLogin) ? _c('div', {
    attrs: {
      "id": "validating-login"
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.shouldShowLandingPage || _vm.failedLogin) ? [_c('div', {
    attrs: {
      "id": "headline"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "login-container"
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleLoginForm($event)
      }
    }
  }, [(!_vm.showLoginForm) ? [_vm._v("Login")] : [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Return")]], 2)])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "upsell"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.showLoginForm) ? [_c('login-form')] : _c('div', {
    attrs: {
      "id": "pitch-container"
    }
  }, [_c('div', {
    staticClass: "pitch"
  }, [_c('div', {
    staticClass: "description"
  }, [_c('h1', [_c('i', {
    staticClass: "fa fa-video-camera"
  }), _vm._v(" Free Video Chat")]), _vm._v(" "), _c('h1', [_c('i', {
    staticClass: "fa fa-user-plus"
  }), _vm._v(" Make New Friends")]), _vm._v(" "), _c('h1', [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" No Download")]), _vm._v(" "), _c('h1', [_c('i', {
    staticClass: "fa fa-money"
  }), _vm._v(" 100% Free!")])]), _vm._v(" "), _c('div', {
    staticClass: "preview"
  }, [_c('img', {
    attrs: {
      "src": "/static/landing-page-preview-image.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "registration"
  }, [_c('register-form')], 1)])], 2), _vm._v(" "), _c('div', {
    attrs: {
      "id": "ad-container"
    }
  }, [_c('ad-container', {
    attrs: {
      "ad-slot": "2462240339"
    }
  })], 1)], 1), _vm._v(" "), (!_vm.showLoginForm) ? [_c('h1', {
    attrs: {
      "id": "feature-header"
    }
  }, [_vm._v("Features")]), _vm._v(" "), _vm._m(2)] : _vm._e()] : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading large"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" "), _c('p', [_vm._v("Validating Login")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-container"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/static/mixsii-logo.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "features"
    }
  }, [_c('div', {
    staticClass: "feature"
  }, [_c('h1', [_vm._v("1 on 1 Video Calls")]), _vm._v(" "), _c('p', [_vm._v("HD Video Chat with friends, family, and strangers completely free from your web browser. No download required to make it work!")])]), _vm._v(" "), _c('div', {
    staticClass: "feature"
  }, [_c('h1', [_vm._v("Group Video Calls")]), _vm._v(" "), _c('p', [_vm._v("HD Video Chat with a whole group! Video Conferencing is free, easy to set up, and fun!")])]), _vm._v(" "), _c('div', {
    staticClass: "feature"
  }, [_c('h1', [_vm._v("Share Gifs")]), _vm._v(" "), _c('p', [_vm._v("Chat has never been more fun with the ability to easily search and send animated Gifs right into the chatroom!")])]), _vm._v(" "), _c('div', {
    staticClass: "feature"
  }, [_c('h1', [_vm._v("Meet New People")]), _vm._v(" "), _c('p', [_vm._v("With public chatrooms, group chats, and private chats, you can chat how ever you want to! Make friends that will last a life time. Video Chatting strangers is fun and safe!")])]), _vm._v(" "), _c('div', {
    staticClass: "feature"
  }, [_c('h1', [_vm._v("Share Files")]), _vm._v(" "), _c('p', [_vm._v("Upload and send files to your friends and group chats easily with the click of a button. On mobile, you can even send a live camera picture.")])]), _vm._v(" "), _c('div', {
    staticClass: "feature"
  }, [_c('h1', [_vm._v("User Profiles")]), _vm._v(" "), _c('p', [_vm._v("Express yourself on your Profile with a Bio and up to ten photos. Browse other members profiles to find new friends, look at photos, and read bios.")])]), _vm._v(" "), _c('div', {
    staticClass: "feature"
  }, [_c('h1', [_vm._v("Cross-Platform")]), _vm._v(" "), _c('p', [_vm._v("Mixsii works on all browsers and mobile devices! It looks good on Desktop, Tablet, and Mobile. Video Chat also works on all platforms!")])]), _vm._v(" "), _c('div', {
    staticClass: "feature"
  }, [_c('h1', [_vm._v("Themes")]), _vm._v(" "), _c('p', [_vm._v("Customize the way your chat panel looks by selecting your own color pallet!")])]), _vm._v(" "), _c('div', {
    staticClass: "feature"
  }, [_c('h1', [_vm._v("Markdown Text Messages")]), _vm._v(" "), _c('p', [_vm._v("All Chat Messages support the Markdown Language, allowing you to easily format text posts with bold and italic words.")])])])
}]}

/***/ }),
/* 385 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view'), _vm._v(" "), _c('modal')], 1)
},staticRenderFns: []}

/***/ }),
/* 386 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    class: ['theme-' + _vm.selectedTheme, {
      'rolled-out': _vm.isRolledOut
    }],
    attrs: {
      "id": "chat-side-panel"
    }
  }, [_c('div', [_c('div', {
    attrs: {
      "id": "logo-container"
    }
  }, [_c('i', {
    staticClass: "fa fa-bars toggle-side-panel",
    on: {
      "click": function($event) {
        return _vm.toggleRollOut()
      }
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('logged-details')], 1), _vm._v(" "), _c('div', [_c('online-users')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "logo"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/mixsii-logo.svg"
    }
  })])
}]}

/***/ }),
/* 387 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.expanded) ? _c('div', {
    staticClass: "fake-youtube-container",
    on: {
      "click": function($event) {
        _vm.expanded = true
      }
    }
  }, [_c('img', {
    attrs: {
      "src": ("https://img.youtube.com/vi/" + _vm.videoCode + "/0.jpg")
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-youtube-play fa-stack-1x"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-youtube-play fa-stack-1x"
  })]) : _vm._e(), _vm._v(" "), (_vm.expanded) ? _c('div', {
    staticClass: "youtube-iframe-wrapper"
  }, [_c('iframe', {
    staticClass: "real-youtube-container",
    attrs: {
      "src": ("https://www.youtube.com/embed/" + _vm.videoCode + "?autoplay=1"),
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 388 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading large"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" "), _c('p', [_vm._v("Saving")])])
}]}

/***/ }),
/* 389 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.photos.length > 0 || _vm.isOwnProfile) ? _c('h1', [_vm._v("Photos")]) : _vm._e(), _vm._v(" "), (_vm.photos.length > 0 || _vm.isOwnProfile) ? _c('div', {
    staticClass: "photos"
  }, [_c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "id": "upload-file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.uploadPhoto
    }
  }), _vm._v(" "), _vm._l((_vm.photos), function(photo) {
    return [_c('div', {
      staticClass: "photo-container"
    }, [_c('div', {
      staticClass: "photo",
      style: (("background-image: url('/profilePhotos/member_" + _vm.memberId + "/" + (photo.photoUrl) + "')")),
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.showInModal(photo)
        }
      }
    }), _vm._v(" "), (_vm.isOwnProfile) ? _c('button', {
      staticClass: "photo-button",
      attrs: {
        "disabled": _vm.deletingPhoto
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.deletePhoto(photo)
        }
      }
    }, [_vm._v("Delete")]) : _vm._e()])]
  }), _vm._v(" "), (_vm.isOwnProfile && !_vm.isUploading) ? _c('label', {
    staticClass: "add-photo",
    attrs: {
      "for": "upload-file"
    }
  }, [_vm._v("Add a Photo")]) : _vm._e(), _vm._v(" "), (_vm.isOwnProfile && _vm.isUploading) ? _c('button', {
    staticClass: "add-photo",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Uploading...")]) : _vm._e()], 2) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 390 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    attrs: {
      "id": "legal-document"
    }
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    attrs: {
      "id": "content"
    }
  }, [_c('router-view')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "headline"
    }
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/static/mixsii-logo.svg"
    }
  })])])
}]}

/***/ }),
/* 391 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    class: [{
      'rolled-out': _vm.isRolledOut
    }],
    attrs: {
      "id": "chat-layout"
    },
    on: {
      "mousemove": _vm.clearTitle
    }
  }, [(!_vm.fetchingLoginStatus && _vm.isLoggedIn) ? [_c('chat-side-panel'), _vm._v(" "), _c('chat-panel'), _vm._v(" "), _c('active-chats-panel')] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 392 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "online-users"
    }
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    attrs: {
      "id": "online-users-list"
    }
  }, _vm._l((_vm.onlineUsers), function(user) {
    return _c('a', {
      key: user.id,
      attrs: {
        "href": ("/Profile/" + (user.stringUrl)),
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "avatar",
      attrs: {
        "src": _vm.avatarImage(user)
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(user.alias))])])
  }), 0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('i', {
    staticClass: "fa fa-fw fa-sun-o"
  }), _vm._v(" Online Users")])
}]}

/***/ }),
/* 393 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading small"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" "), _c('p', [_vm._v("Loading")])])
}]}

/***/ }),
/* 394 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "chat-panel"
    }
  }, [_c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showPanelEmoji && !_vm.showPanelCommands && !_vm.showPanelGiphy && !_vm.themeSelectorEnabled && !_vm.publicGroupsSelected),
      expression: "!showPanelEmoji && !showPanelCommands && !showPanelGiphy && !themeSelectorEnabled && !publicGroupsSelected"
    }, {
      name: "images-loaded",
      rawName: "v-images-loaded",
      value: (_vm.scrollDownMessages),
      expression: "scrollDownMessages"
    }],
    class: [{
      'dark': _vm.isDarkMode
    }],
    attrs: {
      "id": "chat-messages"
    }
  }, [(_vm.fetchingMessages) ? _c('loader-large') : _vm._e(), _vm._v(" "), (!_vm.fetchingMessages) ? _c('ul', {
    attrs: {
      "id": "chat-messages-list"
    }
  }, _vm._l((_vm.chatMessages), function(message) {
    return _c('li', {
      key: message.type === 'group' ? message.messages[0].id : message.id,
      staticClass: "message"
    }, [(message.type !== 'group' && message.posterId !== 0) ? _c('a', {
      attrs: {
        "href": ("/Profile/" + (message.posterStringUrl)),
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "avatar",
      attrs: {
        "src": _vm.generateAvatarImage(message)
      }
    })]) : _vm._e(), _vm._v(" "), (message.type === 'group') ? _c('a', {
      attrs: {
        "href": ("/Profile/" + (message.messages[0].posterStringUrl)),
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "avatar",
      attrs: {
        "src": _vm.generateAvatarImage(message.messages[0])
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "message-details"
    }, [(message.type !== 'group' && message.posterId !== 0) ? [_c('span', {
      staticClass: "message-header"
    }, [(message.posterId !== _vm.ownId) ? _c('span', {
      staticClass: "alias",
      on: {
        "click": function($event) {
          return _vm.tagUser(message.posterAlias)
        }
      }
    }, [_vm._v(_vm._s(message.posterAlias))]) : _vm._e(), _vm._v(" "), (message.posterId === _vm.ownId) ? _c('span', {
      staticClass: "alias"
    }, [_vm._v("You")]) : _vm._e(), _vm._v(" "), (message.posterId !== _vm.ownId) ? _c('span', {
      staticClass: "rating"
    }, [_c('i', {
      class: ['fa fa-arrow-up up', {
        highlighted: message.loggedVoteValue === 1
      }],
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.voteUserUp(message.posterId)
        }
      }
    }), _vm._v(" "), _c('i', {
      class: ['fa fa-arrow-down down', {
        highlighted: message.loggedVoteValue === -1
      }],
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.voteUserDown(message.posterId)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "value"
    }, [_vm._v(_vm._s(message.voteValue))]), _vm._v(" "), (!message.isIgnored) ? _c('span', {
      staticClass: "ignore",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.ignoreUser(message.posterId)
        }
      }
    }, [_vm._v("Ignore")]) : _vm._e(), _vm._v(" "), (message.isIgnored) ? _c('span', {
      staticClass: "ignore",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.ignoreUser(message.posterId)
        }
      }
    }, [_vm._v("Un-Ignore")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (message.posterId === _vm.ownId) ? _c('span', {
      staticClass: "rating"
    }, [_c('span', {
      staticClass: "value"
    }, [_vm._v(_vm._s(message.voteValue))])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "bubble"
    }, [(!message.isIgnored && message.voteValue > _vm.userVoteThreshold) ? _c('span', {
      staticClass: "individual-message"
    }, [_c('markdown-content', {
      staticClass: "individual-message-content",
      attrs: {
        "content": message.message
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "timestamp"
    }, [_vm._v(_vm._s(_vm._f("formatDate")(message.timestamp)))])], 1) : _vm._e(), _vm._v(" "), (message.isIgnored || message.voteValue <= _vm.userVoteThreshold) ? _c('span', {
      staticClass: "individual-message"
    }, [_c('markdown-content', {
      staticClass: "individual-message-content",
      attrs: {
        "content": "*::::Blocked Messages::::*"
      }
    })], 1) : _vm._e()])] : _vm._e(), _vm._v(" "), (message.type === 'group') ? [_c('span', {
      staticClass: "message-header"
    }, [(message.messages[0].posterId !== _vm.ownId) ? _c('span', {
      staticClass: "alias",
      on: {
        "click": function($event) {
          return _vm.tagUser(message.messages[0].posterAlias)
        }
      }
    }, [_vm._v("\n                                  " + _vm._s(message.messages[0].posterAlias) + "\n                              ")]) : _vm._e(), _vm._v(" "), (message.messages[0].posterId === _vm.ownId) ? _c('span', {
      staticClass: "alias"
    }, [_vm._v("You")]) : _vm._e(), _vm._v(" "), (message.messages[0].posterId !== _vm.ownId) ? _c('span', {
      staticClass: "rating"
    }, [_c('i', {
      class: ['fa fa-arrow-up up', {
        highlighted: message.messages[0].loggedVoteValue === 1
      }],
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.voteUserUp(message.messages[0].posterId)
        }
      }
    }), _vm._v(" "), _c('i', {
      class: ['fa fa-arrow-down down', {
        highlighted: message.messages[0].loggedVoteValue === -1
      }],
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.voteUserDown(message.messages[0].posterId)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "value"
    }, [_vm._v(_vm._s(message.messages[0].voteValue))]), _vm._v(" "), (!message.messages[0].isIgnored) ? _c('span', {
      staticClass: "ignore",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.ignoreUser(message.messages[0].posterId)
        }
      }
    }, [_vm._v("Ignore")]) : _vm._e(), _vm._v(" "), (message.messages[0].isIgnored) ? _c('span', {
      staticClass: "ignore",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.ignoreUser(message.messages[0].posterId)
        }
      }
    }, [_vm._v("Un-Ignore")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (message.messages[0].posterId === _vm.ownId) ? _c('span', {
      staticClass: "rating"
    }, [_c('span', {
      staticClass: "value"
    }, [_vm._v(_vm._s(message.messages[0].voteValue))])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "bubble"
    }, [_vm._l((message.messages), function(singleMessage) {
      return (!message.messages[0].isIgnored && message.messages[0].voteValue > _vm.userVoteThreshold) ? _c('span', {
        staticClass: "individual-message"
      }, [_c('markdown-content', {
        staticClass: "individual-message-content",
        attrs: {
          "content": singleMessage.message
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "timestamp"
      }, [_vm._v(_vm._s(_vm._f("formatDate")(singleMessage.timestamp)))])], 1) : _vm._e()
    }), _vm._v(" "), (message.messages[0].isIgnored || message.messages[0].voteValue <= _vm.userVoteThreshold) ? _c('span', {
      staticClass: "individual-message"
    }, [_c('markdown-content', {
      staticClass: "individual-message-content",
      attrs: {
        "content": "*::::Blocked Messages::::*"
      }
    })], 1) : _vm._e()], 2)] : _vm._e(), _vm._v(" "), (message.posterId === 0) ? [_c('div', {
      staticClass: "bubble"
    }, [_c('span', {
      staticClass: "individual-message system-message"
    }, [_c('markdown-content', {
      staticClass: "individual-message-content",
      attrs: {
        "content": message.message
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "timestamp"
    }, [_vm._v(_vm._s(_vm._f("formatDate")(message.timestamp)))])], 1)])] : _vm._e()], 2)])
  }), 0) : _vm._e()], 1), _vm._v(" "), (_vm.themeSelectorEnabled) ? _c('theme-selector', {
    on: {
      "exitThemeSelectMode": _vm.exitThemeSelectMode
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showPanelEmoji) ? _c('section', {
    class: [{
      'dark': _vm.isDarkMode
    }],
    attrs: {
      "id": "chat-help-emoji"
    }
  }, _vm._l((_vm.emojiList), function(emoji) {
    return _c('div', {
      staticClass: "emoji",
      attrs: {
        "title": emoji.alias
      },
      on: {
        "click": function($event) {
          return _vm.addEmoji(emoji.emoji)
        }
      }
    }, [_vm._v("\n      " + _vm._s(emoji.emoji) + "\n    ")])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.showPanelCommands) ? _c('section', {
    class: [{
      'dark': _vm.isDarkMode
    }],
    attrs: {
      "id": "chat-help-commands"
    }
  }, [_c('h1', [_vm._v("Chat Commands")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)]) : _vm._e(), _vm._v(" "), (_vm.showPanelGiphy) ? _c('section', {
    class: [{
      'dark': _vm.isDarkMode
    }],
    attrs: {
      "id": "chat-giphy-panel"
    }
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "results-list"
  }, [(_vm.giphySearching) ? _c('loader-large') : _vm._e(), _vm._v(" "), _vm._l((_vm.giphyResults), function(giphyResult) {
    return (!_vm.giphySearching) ? _c('div', {
      staticClass: "result-container",
      on: {
        "click": function($event) {
          return _vm.addGiphyToChat(giphyResult.id)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": giphyResult.images.fixed_height.url
      }
    })]) : _vm._e()
  })], 2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.giphySearch),
      expression: "giphySearch"
    }],
    ref: "giphyInput",
    attrs: {
      "type": "text",
      "placeholder": "Search for a Gif..."
    },
    domProps: {
      "value": (_vm.giphySearch)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.giphySearch = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.publicGroupsSelected) ? _c('section', {
    class: [{
      'dark': _vm.isDarkMode
    }],
    attrs: {
      "id": "chat-public-groups-list"
    }
  }, [_c('h1', [_vm._v("Public Groups")]), _vm._v(" "), (_vm.publicGroupList.length === 0) ? _c('div', {
    staticClass: "validation"
  }, [_vm._v("There are no public groups that you haven't\n      joined\n    ")]) : _vm._e(), _vm._v(" "), (_vm.publicGroupList.length > 0) ? _c('ul', _vm._l((_vm.publicGroupList), function(publicGroup) {
    return _c('li', [_c('button', {
      attrs: {
        "disabled": _vm.joiningPublicGroup
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.joinPublicGroup(publicGroup.id)
        }
      }
    }, [_vm._v("Join Group\n        ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(publicGroup.memberCount) + " Member"), (publicGroup.memberCount !== 1) ? [_vm._v("s")] : _vm._e()], 2), _vm._v(" "), _c('span', [_vm._v(_vm._s(publicGroup.alias))])])
  }), 0) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('section', {
    class: [{
      'dark': _vm.isDarkMode
    }],
    attrs: {
      "id": "chat-inputs"
    }
  }, [_c('form', {
    attrs: {
      "id": "chat-input"
    }
  }, [_c('div', {
    staticClass: "chat-options"
  }, [_c('i', {
    class: ['fa', 'fa-question-circle-o', 'option-help', {
      selected: _vm.showPanelCommands
    }],
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleCommandsPanel($event)
      }
    }
  }), _vm._v(" "), _c('i', {
    class: ['fa', 'fa-smile-o', 'option-emoji', {
      selected: _vm.showPanelEmoji
    }],
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleEmojiPanel($event)
      }
    }
  }), _vm._v(" "), _c('i', {
    class: ['fa', 'option-gif', {
      selected: _vm.showPanelGiphy
    }],
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleGiphyPanel($event)
      }
    }
  }, [_vm._v("gif")]), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "attach-file",
      "name": "attach-file",
      "type": "file"
    },
    on: {
      "change": _vm.uploadFile
    }
  }), _vm._v(" "), (!_vm.isUploading) ? _c('label', {
    attrs: {
      "for": "attach-file"
    }
  }, [_c('i', {
    staticClass: "fa fa-paperclip option-attach"
  })]) : _vm._e(), _vm._v(" "), (_vm.isUploading) ? _c('i', {
    staticClass: "fa fa-spin fa-spinner"
  }) : _vm._e(), _vm._v(" "), _c('i', {
    class: ['fa', 'fa-dashboard', 'option-theme', {
      selected: _vm.themeSelectorEnabled
    }],
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleThemeSelector($event)
      }
    }
  }), _vm._v(" "), _c('i', {
    class: ['fa', 'fa-users', 'option-public-groups', {
      selected: _vm.publicGroupsSelected
    }],
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.togglePublicGroups($event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "chat-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newMessage),
      expression: "newMessage"
    }],
    ref: "inputChatBox",
    attrs: {
      "type": "text",
      "placeholder": "Type Here...",
      "maxlength": "600"
    },
    domProps: {
      "value": (_vm.newMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newMessage = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submitMessage($event)
      }
    }
  }, [_vm._v("Send")])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "command-entry"
  }, [_c('span', {
    staticClass: "command"
  }, [_vm._v("some *text* example")]), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v("Italicizes text: some "), _c('em', [_vm._v("text")]), _vm._v(" example")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "command-entry"
  }, [_c('span', {
    staticClass: "command"
  }, [_vm._v("some **text** example")]), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v("Bolds text: some "), _c('strong', [_vm._v("text")]), _vm._v(" example")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "command-entry"
  }, [_c('span', {
    staticClass: "command"
  }, [_vm._v("/me mesage")]), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v("Sends an action message")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "command-entry"
  }, [_c('span', {
    staticClass: "command"
  }, [_vm._v("/flip or /flipcoin")]), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v("Flips a coin and gives the result")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "command-entry"
  }, [_c('span', {
    staticClass: "command"
  }, [_vm._v("/roll")]), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v("Rolls a Six-Sided Dice")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "command-entry"
  }, [_c('span', {
    staticClass: "command"
  }, [_vm._v("/roll XdY")]), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v("Rolls X Y-Sided Dice. Example: "), _c('em', [_vm._v("/roll 4d10")]), _vm._v(" rolls 4 10 sided dice.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "powered-by-giphy"
  }, [_c('img', {
    attrs: {
      "src": "/static/powered-by-giphy.png"
    }
  })])
}]}

/***/ }),
/* 395 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Privacy Policy")]), _vm._v(" "), _c('p', [_vm._v("This privacy policy has been compiled to better serve those who are concerned with how their 'Personally Identifiable Information' (PII) is being used online. PII, as described in US privacy law and information security, is information that can be used on its own or with other information to identify, contact, or locate a single person, or to identify an individual in context. Please read our privacy policy carefully to get a clear understanding of how we collect, use, protect or\n        otherwise handle your Personally Identifiable Information in accordance with our website.")]), _vm._v(" "), _c('h1', [_vm._v("What personal information do we collect from the people that visit our blog, website or app?")]), _vm._v(" "), _c('p', [_vm._v("When registering on our site, as appropriate, you may be asked to enter your name, email address or other details to help you with your experience.")]), _vm._v(" "), _c('h1', [_vm._v("When do we collect information?")]), _vm._v(" "), _c('p', [_vm._v("We collect information from you when you register on our site or enter information on our site.")]), _vm._v(" "), _c('h1', [_vm._v("How do we use your information?")]), _vm._v(" "), _c('p', [_vm._v("We may use the information we collect from you when you register or add details to your profile in order to personalize your experience and to allow us to deliver the type of content and product offerings in which you are most interested.")]), _vm._v(" "), _c('h1', [_vm._v("How do we protect your information?")]), _vm._v(" "), _c('p', [_vm._v("Your personal information is contained behind secured networks and is only accessible by a limited number of persons who have special access rights to such systems, and are required to keep the information confidential. In addition, all sensitive/credit information you supply is encrypted via Secure Socket Layer (SSL) technology.")]), _vm._v(" "), _c('p', [_vm._v("We implement a variety of security measures when a user enters, submits, or accesses their information to maintain the safety of your personal information.")]), _vm._v(" "), _c('p', [_vm._v("All transactions are processed through a gateway provider and are not stored or processed on our servers.")]), _vm._v(" "), _c('h1', [_vm._v("Do we use 'cookies'?")]), _vm._v(" "), _c('p', [_vm._v("We do not use cookies for tracking purposes.")]), _vm._v(" "), _c('p', [_vm._v("You can choose to have your computer warn you each time a cookie is being sent, or you can choose to turn off all cookies. You do this through your browser settings. Since browser is a little different, look at your browser's Help Menu to learn the correct way to modify your cookies.")]), _vm._v(" "), _c('p', [_vm._v("If you turn cookies off, Some of the features that make your site experience more efficient may not function properly that make your site experience more efficient and may not function properly.")]), _vm._v(" "), _c('h1', [_vm._v("Third-party disclosure")]), _vm._v(" "), _c('p', [_vm._v("We do not sell, trade, or otherwise transfer to outside parties your Personally Identifiable Information unless we provide users with advance notice. This does not include website hosting partners and other parties who assist us in operating our website, conducting our business, or serving our users, so long as those parties agree to keep this information confidential. We may also release information when it's release is appropriate to comply with the law, enforce our site\n        policies, or protect ours or others' rights, property or safety. ")]), _vm._v(" "), _c('h1', [_vm._v("Third-party links")]), _vm._v(" "), _c('p', [_vm._v("Occasionally, at our discretion, we may include or offer third-party products or services on our website. These third-party sites have separate and independent privacy policies. We therefore have no responsibility or liability for the content and activities of these linked sites. Nonetheless, we seek to protect the integrity of our site and welcome any feedback about these sites.")]), _vm._v(" "), _c('h1', [_vm._v("Google")]), _vm._v(" "), _c('p', [_vm._v("Google's advertising requirements can be summed up by Google's Advertising Principles. They are put in place to provide a positive experience for users "), _c('a', {
    attrs: {
      "href": "https://support.google.com/adwordspolicy/answer/1316548?hl=en"
    }
  }, [_vm._v("https://support.google.com/adwordspolicy/answer/1316548?hl=en")]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("We use Google AdSense Advertising on our website.")]), _vm._v(" "), _c('p', [_vm._v("Google, as a third-party vendor, uses cookies to serve ads on our site. Google's use of the DART cookie enables it to serve ads to our users based on previous visits to our site and other sites on the Internet. Users may opt-out of the use of the DART cookie by visiting the Google Ad and Content Network privacy policy.")]), _vm._v(" "), _c('p', [_vm._v("We have implemented the following: Remarketing with Google AdSense")]), _vm._v(" "), _c('p', [_vm._v("We, along with third-party vendors such as Google use first-party cookies (such as the Google Analytics cookies) and third-party cookies (such as the DoubleClick cookie) or other third-party identifiers together to compile data regarding user interactions with ad impressions and other ad service functions as they relate to our website.")]), _vm._v(" "), _c('p', [_vm._v("Opting out:")]), _vm._v(" "), _c('p', [_vm._v("Users can set preferences for how Google advertises to you using the Google Ad Settings page. Alternatively, you can opt out by visiting the Network Advertising Initiative Opt Out page or by using the Google Analytics Opt Out Browser add on.")]), _vm._v(" "), _c('h1', [_vm._v("California Online Privacy Protection Act")]), _vm._v(" "), _c('p', [_vm._v("CalOPPA is the first state law in the nation to require commercial websites and online services to post a privacy policy. The law's reach stretches well beyond California to require any person or company in the United States (and conceivably the world) that operates websites collecting Personally Identifiable Information from California consumers to post a conspicuous privacy policy on its website stating exactly the information being collected and those individuals or companies\n        with whom it is being shared. - See more at: "), _c('a', {
    attrs: {
      "href": "http://consumercal.org/california-online-privacy-protection-act-caloppa/#sthash.0FdRbT51.dpuf"
    }
  }, [_vm._v("http://consumercal.org/california-online-privacy-protection-act-caloppa/#sthash.0FdRbT51.dpuf")]), _vm._v(".\n    ")]), _c('p'), _c('p', [_vm._v("According to CalOPPA, we agree to the following:")]), _vm._v(" "), _c('p', [_vm._v("Users can visit our site anonymously.")]), _vm._v(" "), _c('p', [_vm._v("Once this privacy policy is created, we will add a link to it on our home page or as a minimum, on the first significant page after entering our website.")]), _vm._v(" "), _c('p', [_vm._v("Our Privacy Policy link includes the word 'Privacy' and can easily be found on the page specified above.")]), _vm._v(" "), _c('p', [_vm._v("You will be notified of any Privacy Policy changes on our Privacy Policy Page.")]), _vm._v(" "), _c('p', [_vm._v("Can change your personal information by logging in to your account.")]), _vm._v(" "), _c('h1', [_vm._v("How does our site handle Do Not Track signals?")]), _vm._v(" "), _c('p', [_vm._v("We honor Do Not Track signals and Do Not Track, plant cookies, or use advertising when a Do Not Track (DNT) browser mechanism is in place.")]), _vm._v(" "), _c('h1', [_vm._v("Does our site allow third-party behavioral tracking?")]), _vm._v(" "), _c('p', [_vm._v("It's also important to note that we allow third-party behavioral tracking")]), _vm._v(" "), _c('h1', [_vm._v("COPPA (Children Online Privacy Protection Act)")]), _vm._v(" "), _c('p', [_vm._v("When it comes to the collection of personal information from children under the age of 13 years old, the Children's Online Privacy Protection Act (COPPA) puts parents in control. The Federal Trade Commission, United States' consumer protection agency, enforces the COPPA Rule, which spells out what operators of websites and online services must do to protect children's privacy and safety online.")]), _vm._v(" "), _c('p', [_vm._v("We do not specifically market to children under the age of 13 years old.")]), _vm._v(" "), _c('h1', [_vm._v("Fair Information Practices")]), _vm._v(" "), _c('p', [_vm._v("The Fair Information Practices Principles form the backbone of privacy law in the United States and the concepts they include have played a significant role in the development of data protection laws around the globe. Understanding the Fair Information Practice Principles and how they should be implemented is critical to comply with the various privacy laws that protect personal information.")]), _vm._v(" "), _c('p', [_vm._v("In order to be in line with Fair Information Practices we will take the following responsive action, should a data breach occur: We will notify you via email Within 7 business days")]), _vm._v(" "), _c('p', [_vm._v("We also agree to the Individual Redress Principle which requires that individuals have the right to legally pursue enforceable rights against data collectors and processors who fail to adhere to the law. This principle requires not only that individuals have enforceable rights against data users, but also that individuals have recourse to courts or government agencies to investigate and/or prosecute non-compliance by data processors.")]), _vm._v(" "), _c('h1', [_vm._v("CAN SPAM Act")]), _vm._v(" "), _c('p', [_vm._v("The CAN-SPAM Act is a law that sets the rules for commercial email, establishes requirements for commercial messages, gives recipients the right to have emails stopped from being sent to them, and spells out tough penalties for violations.")]), _vm._v(" "), _c('p', [_vm._v("We collect your email address in order to allow you to log into your account, send information, respond to inquiries, and/or other requests or questions.")]), _vm._v(" "), _c('p', [_vm._v("To be in accordance with CANSPAM, we agree to the following:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Not use false or misleading subjects or email addresses.")]), _vm._v(" "), _c('li', [_vm._v("Identify the message as an advertisement in some reasonable way.")]), _vm._v(" "), _c('li', [_vm._v("Include the physical address of our business or site headquarters.")]), _vm._v(" "), _c('li', [_vm._v("Monitor third-party email marketing services for compliance, if one is used.")]), _vm._v(" "), _c('li', [_vm._v("Honor opt-out/unsubscribe requests quickly.")]), _vm._v(" "), _c('li', [_vm._v("Allow users to unsubscribe by using the link at the bottom of each email.")])]), _vm._v(" "), _c('p', [_vm._v("If at any time you would like to unsubscribe from receiving future emails, you follow the instructions at the bottom of each email and we will promptly remove you from ALL correspondence.")]), _vm._v(" "), _c('h1', [_vm._v("Contacting Us")]), _vm._v(" "), _c('p', [_vm._v("If there are any questions regarding this privacy policy, you may contact us using the information below.")]), _vm._v(" "), _c('p', [_vm._v("mixsii.com")]), _vm._v(" "), _c('p', [_vm._v("Last Edited on 2017-07-21")])])
}]}

/***/ }),
/* 396 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    attrs: {
      "id": "profile-layout"
    }
  }, [_c('profile-page')], 1)
},staticRenderFns: []}

/***/ }),
/* 397 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "group-details"
    }
  }, [(_vm.fetchedInitialGroupDetails && !_vm.leaveGroupMode) ? [(!_vm.changeGroupNameMode) ? [_c('div', {
    key: "group-details",
    staticClass: "group-details"
  }, [_c('h1', [(_vm.groupDetails.isPublic) ? _c('span', [_vm._v("Public")]) : _vm._e(), _vm._v(" Group: " + _vm._s(_vm.groupDetails.name))]), _vm._v(" "), (_vm.moderatorStatus === 'owner') ? _c('a', {
    attrs: {
      "href": "#change-group-name"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changeGroupNameMode = true;
      }
    }
  }, [_vm._v("Change Group Name")]) : _vm._e(), _vm._v(" "), (_vm.moderatorStatus === 'owner' && !_vm.groupDetails.isPublic) ? _c('a', {
    attrs: {
      "href": "#make-public"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changePublicStatus(true)
      }
    }
  }, [_vm._v("Make Group Public")]) : _vm._e(), _vm._v(" "), (_vm.moderatorStatus === 'owner' && _vm.groupDetails.isPublic) ? _c('a', {
    attrs: {
      "href": "#make-private"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changePublicStatus(false)
      }
    }
  }, [_vm._v("Make Group Private")]) : _vm._e(), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#leave-group"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.leaveGroupMode = true;
      }
    }
  }, [_vm._v("Leave Group")])])] : _vm._e(), _vm._v(" "), (_vm.changeGroupNameMode) ? [_c('div', {
    key: "group-update-name",
    staticClass: "group-update-name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newGroupName),
      expression: "newGroupName"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Group name...",
      "disabled": _vm.savingNewGroupName
    },
    domProps: {
      "value": (_vm.newGroupName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newGroupName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "button-container"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.savingNewGroupName
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changeGroupNameMode = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.savingNewGroupName
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateGroupName($event)
      }
    }
  }, [_vm._v("Submit")])])])] : _vm._e(), _vm._v(" "), _c('h1', [_vm._v("\n            Members\n            "), (!_vm.inviteMemberMode) ? _c('a', {
    attrs: {
      "href": "#invite-member"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.inviteMemberMode = true
      }
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.inviteMemberMode) ? _c('a', {
    attrs: {
      "href": "#return-from-invite-member"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.inviteMemberMode = false
      }
    }
  }, [_vm._m(1)]) : _vm._e()]), _vm._v(" "), (!_vm.inviteMemberMode) ? _c('section', {
    attrs: {
      "id": "members"
    }
  }, [_c('ul', _vm._l((_vm.groupDetails.members), function(user) {
    return _c('li', {
      key: user.id
    }, [_c('a', {
      attrs: {
        "href": ("/Profile/" + (user.stringUrl)),
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "avatar",
      attrs: {
        "src": _vm.avatarImage(user)
      }
    }), _vm._v(" "), (user.isOnline) ? _c('i', {
      staticClass: "fa fa-circle online-status"
    }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(user.alias))]), _vm._v(" "), (user.moderatorStatus === 'owner') ? _c('i', {
      staticClass: "fa fa-star mod-status status-owner"
    }) : _vm._e(), _vm._v(" "), (user.moderatorStatus === 'moderator') ? _c('i', {
      staticClass: "fa fa-star mod-status status-moderator"
    }) : _vm._e()]), _vm._v(" "), (_vm.moderatorStatus === 'owner' || _vm.moderatorStatus === 'moderator') ? _c('span', {
      staticClass: "moderator-controls"
    }, [(user.moderatorStatus !== 'owner' && user.moderatorStatus !== 'moderator') ? _c('a', {
      attrs: {
        "href": "#promote-member"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.promote(user)
        }
      }
    }, [_vm._v("Promote")]) : _vm._e(), _vm._v(" "), (user.moderatorStatus === 'moderator' && user.id !== _vm.ownId) ? _c('a', {
      attrs: {
        "href": "#demote-member"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.demote(user)
        }
      }
    }, [_vm._v("Demote")]) : _vm._e(), _vm._v(" "), (user.moderatorStatus !== 'owner' && user.moderatorStatus !== 'moderator') ? _c('a', {
      attrs: {
        "href": "#kick-member"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.kick(user)
        }
      }
    }, [_vm._v("Kick")]) : _vm._e()]) : _vm._e()])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.inviteMemberMode) ? _c('section', {
    attrs: {
      "id": "add-member"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inviteMemberValue),
      expression: "inviteMemberValue"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Search for a user..."
    },
    domProps: {
      "value": (_vm.inviteMemberValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inviteMemberValue = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.inviteMemberValue.length > 0 && _vm.filteredInviteMembersList.length === 0) ? _c('h1', [_vm._v("No Matching Members Found")]) : _vm._e(), _vm._v(" "), _c('ul', _vm._l((_vm.filteredInviteMembersList), function(user) {
    return _c('li', {
      key: user.id
    }, [_c('a', {
      staticClass: "add-member-button",
      attrs: {
        "href": "#add"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.addMember(user)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus-circle"
    })]), _vm._v(" "), _c('a', {
      attrs: {
        "href": ("/Profile/" + (user.stringUrl)),
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "avatar",
      attrs: {
        "src": _vm.avatarImage(user)
      }
    }), _vm._v(" "), (user.isOnline) ? _c('i', {
      staticClass: "fa fa-circle online-status"
    }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(user.alias))]), _vm._v(" "), (user.moderatorStatus === 'owner') ? _c('i', {
      staticClass: "fa fa-star mod-status status-owner"
    }) : _vm._e(), _vm._v(" "), (user.moderatorStatus === 'moderator') ? _c('i', {
      staticClass: "fa fa-star mod-status status-moderator"
    }) : _vm._e()])])
  }), 0)]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.leaveGroupMode) ? [_c('div', {
    staticClass: "leave-group"
  }, [_c('h1', [_vm._v("Really leave this group?")]), _vm._v(" "), _c('div', {
    staticClass: "button-container"
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.leaveGroupMode = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.leaveGroup($event)
      }
    }
  }, [_vm._v("Leave")])]), _vm._v(" "), (_vm.moderatorStatus === 'owner' && _vm.groupDetails.members.length > 1) ? [_c('h1', [_vm._v("New Owner")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newOwner),
      expression: "newOwner"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newOwner = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.groupDetails.members), function(user) {
    return (user.id !== _vm.ownId) ? _c('option', {
      domProps: {
        "value": user.id
      }
    }, [_vm._v(_vm._s(user.alias))]) : _vm._e()
  }), 0)] : _vm._e()], 2)] : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-plus-circle add-member"
  }), _vm._v(" Invite")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-chevron-circle-left add-member"
  }), _vm._v(" Return")])
}]}

/***/ }),
/* 398 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    attrs: {
      "id": "profile-page"
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.fetchingProfileData) ? _c('div', {
    staticClass: "loader-container"
  }, [_c('loader-large')], 1) : _vm._e(), _vm._v(" "), (!_vm.fetchingProfileData) ? [_c('section', {
    staticClass: "profile-content"
  }, [(_vm.errors.length > 0) ? _c('div', {
    staticClass: "validation error"
  }, _vm._l((_vm.errors), function(error) {
    return _c('span', [_vm._v(_vm._s(error))])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.errors.length === 0) ? [_c('div', {
    staticClass: "details"
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.avatarImage
    }
  }), _vm._v(" "), (_vm.deleteFriendMode) ? _c('div', {
    staticClass: "delete-friend-form"
  }, [_c('h1', [_vm._v("Really Delete?")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.removeFriend($event)
      }
    }
  }, [_vm._v("Yes!")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.deleteFriendMode = false
      }
    }
  }, [_vm._v("Cancel")])]) : _vm._e(), _vm._v(" "), (_vm.editProfileMode) ? _c('div', {
    staticClass: "edit-stats"
  }, [_c('div', {
    staticClass: "stats-properties"
  }, [_c('label', [_c('span', [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editDetails.realName),
      expression: "editDetails.realName"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.editDetails.realName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editDetails, "realName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', [_c('span', [_vm._v("Location")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editDetails.location),
      expression: "editDetails.location"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.editDetails.location)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editDetails, "location", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', [_c('span', [_vm._v("Share Age")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editDetails.showAge),
      expression: "editDetails.showAge"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.editDetails.showAge) ? _vm._i(_vm.editDetails.showAge, null) > -1 : (_vm.editDetails.showAge)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.editDetails.showAge,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.editDetails, "showAge", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.editDetails, "showAge", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.editDetails, "showAge", $$c)
        }
      }
    }
  })]), _vm._v(" "), (_vm.editDetails.showAge) ? _c('label', [_c('span', [_vm._v("Birthday")]), _vm._v(" "), _c('span', {
    staticClass: "select-container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editDetails.birthMonth),
      expression: "editDetails.birthMonth"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editDetails, "birthMonth", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Jan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Feb")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Mar")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Apr")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("May")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("June")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7"
    }
  }, [_vm._v("July")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v("Aug")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("Sep")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("Oct")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "11"
    }
  }, [_vm._v("Nov")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12"
    }
  }, [_vm._v("Dec")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editDetails.birthDay),
      expression: "editDetails.birthDay"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editDetails, "birthDay", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((31), function(n) {
    return _c('option', {
      domProps: {
        "value": n
      }
    }, [_vm._v(_vm._s(n))])
  }), 0), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editDetails.birthYear),
      expression: "editDetails.birthYear"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editDetails, "birthYear", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.yearRange(1900)), function(n) {
    return _c('option', {
      domProps: {
        "value": n
      }
    }, [_vm._v(_vm._s(n))])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('label', [_c('span', [_vm._v("Gender")]), _vm._v(" "), _c('div', {
    staticClass: "sub-label"
  }, [_c('label', [_c('span', [_vm._v("Male")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editDetails.gender),
      expression: "editDetails.gender"
    }],
    attrs: {
      "type": "radio",
      "value": "Male"
    },
    domProps: {
      "checked": _vm._q(_vm.editDetails.gender, "Male")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.editDetails, "gender", "Male")
      }
    }
  })]), _vm._v(" "), _c('label', [_c('span', [_vm._v("Female")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editDetails.gender),
      expression: "editDetails.gender"
    }],
    attrs: {
      "type": "radio",
      "value": "Female"
    },
    domProps: {
      "checked": _vm._q(_vm.editDetails.gender, "Female")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.editDetails, "gender", "Female")
      }
    }
  })])])]), _vm._v(" "), _c('label', [_c('span', [_vm._v("Share Height")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editDetails.showHeight),
      expression: "editDetails.showHeight"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.editDetails.showHeight) ? _vm._i(_vm.editDetails.showHeight, null) > -1 : (_vm.editDetails.showHeight)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.editDetails.showHeight,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.editDetails, "showHeight", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.editDetails, "showHeight", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.editDetails, "showHeight", $$c)
        }
      }
    }
  })]), _vm._v(" "), (_vm.editDetails.showHeight) ? _c('label', [_c('span', [_vm._v("Height")]), _vm._v(" "), (!_vm.useMetric) ? _c('span', {
    staticClass: "select-container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editDetails.heightFeet),
      expression: "editDetails.heightFeet"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editDetails, "heightFeet", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((6), function(n) {
    return _c('option', {
      domProps: {
        "value": n
      }
    }, [_vm._v(_vm._s(n) + "'")])
  }), 0), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editDetails.heightInches),
      expression: "editDetails.heightInches"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editDetails, "heightInches", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((11), function(n) {
    return _c('option', {
      domProps: {
        "value": n
      }
    }, [_vm._v(_vm._s(n) + "\"")])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.useMetric) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editDetails.metricHeight),
      expression: "editDetails.metricHeight"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Height in cm"
    },
    domProps: {
      "value": (_vm.editDetails.metricHeight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editDetails, "metricHeight", $event.target.value)
      }
    }
  }) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveProfileData($event)
      }
    }
  }, [_vm._v("Save")])]) : _vm._e(), _vm._v(" "), (!_vm.deleteFriendMode && !_vm.editProfileMode) ? _c('div', {
    staticClass: "stats"
  }, [_c('div', {
    staticClass: "stats-properties"
  }, [(_vm.profileData.alias) ? _c('span', {
    staticClass: "alias"
  }, [_vm._v(_vm._s(_vm.profileData.alias))]) : _vm._e(), _vm._v(" "), (_vm.profileData.realName) ? _c('span', [_vm._v(_vm._s(_vm.profileData.realName))]) : _vm._e(), _vm._v(" "), (_vm.profileData.location) ? _c('span', [_vm._v(_vm._s(_vm.profileData.location))]) : _vm._e(), _vm._v(" "), (_vm.compoundStats) ? _c('span', [_vm._v(_vm._s(_vm.compoundStats))]) : _vm._e(), _vm._v(" "), (_vm.profileData.registrationDate) ? _c('span', [_vm._v("Member since " + _vm._s(_vm._f("formatDateWithoutTime")(_vm.profileData.registrationDate)))]) : _vm._e()]), _vm._v(" "), (_vm.retrievedFriendStatus) ? [(_vm.buttonToUse === 'addFriend') ? _c('button', {
    attrs: {
      "disabled": _vm.isUpdatingFriendStatus
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addFriend($event)
      }
    }
  }, [_vm._v("Add Friend\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.buttonToUse === 'removeFriend') ? _c('button', {
    attrs: {
      "disabled": _vm.isUpdatingFriendStatus
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.deleteFriendMode = true
      }
    }
  }, [_vm._v("Remove Friend\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.buttonToUse === 'friendRequestSent') ? _c('button', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Friend Request Pending\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.buttonToUse === 'acceptFriend') ? _c('button', {
    attrs: {
      "disabled": _vm.isUpdatingFriendStatus
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.acceptFriendRequest($event)
      }
    }
  }, [_vm._v("Accept Friend Request\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.buttonToUse === 'editProfile') ? _c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.editProfileMode = true
      }
    }
  }, [_vm._v("Edit Profile\n                            ")]) : _vm._e()] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ad-container"
  }, [_c('ad-container', {
    attrs: {
      "ad-slot": "6967449791"
    }
  })], 1)]), _vm._v(" "), _c('photo-manager', {
    attrs: {
      "photos": _vm.profileData.photos,
      "is-own-profile": _vm.isOwnProfile,
      "memberId": _vm.profileData.id
    }
  }), _vm._v(" "), (_vm.profileData.bio || _vm.isOwnProfile) ? _c('h1', [_vm._v("Bio")]) : _vm._e(), _vm._v(" "), (!_vm.editBioMode && _vm.profileData.bio) ? _c('pre', {
    staticClass: "bio"
  }, [_vm._v(_vm._s(_vm.profileData.bio))]) : _vm._e(), _vm._v(" "), (_vm.editBioMode) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editBioContent),
      expression: "editBioContent"
    }],
    staticClass: "edit-bio-content",
    attrs: {
      "maxlength": "600"
    },
    domProps: {
      "value": (_vm.editBioContent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editBioContent = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isOwnProfile && !_vm.editBioMode) ? _c('button', {
    staticClass: "edit-bio-button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.editBioMode = true
      }
    }
  }, [_vm._v("Edit Bio")]) : _vm._e(), _vm._v(" "), (_vm.isOwnProfile && _vm.editBioMode) ? _c('button', {
    staticClass: "edit-bio-button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveBio($event)
      }
    }
  }, [_vm._v("Save Bio")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "large-ad"
  }, [_c('ad-container', {
    attrs: {
      "ad-slot": "2462240339"
    }
  })], 1), _vm._v(" "), _c('browse-more-profiles', {
    attrs: {
      "current-member-id": _vm.profileData.id
    }
  })] : _vm._e()], 2)] : _vm._e(), _vm._v(" "), _c('footer', [_vm._v("Mixsii is a Free Video Chat Room Service, with a list of chat rooms. HD Video Chat with friends, family, and strangers completely free from your web browser. No download required to make it work! Group calls and Video Conferencing is available. Browse the list of video chat rooms for teen, adults, and enthusiasts. Mixsii is cross-browser, and even works on Android and iOS Apple Devices.")])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/mixsii-logo.svg"
    }
  })]), _vm._v(" "), _c('h1', [_vm._v("Free Video Chat Rooms")]), _vm._v(" "), _c('h1', [_c('a', {
    attrs: {
      "href": "/Chat"
    }
  }, [_vm._v("Chat Now!")])])])
}]}

/***/ }),
/* 399 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h1', [_vm._v("Browse More Profiles")]), _vm._v(" "), _c('div', {
    staticClass: "more-profiles"
  }, _vm._l((_vm.browseMembers), function(member) {
    return _c('div', {
      staticClass: "profile-link"
    }, [_c('a', {
      attrs: {
        "href": ("/Profile/" + (member.stringUrl))
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.avatarImage(member)
      }
    }), _c('span', {
      staticClass: "member-name"
    }, [_vm._v(_vm._s(member.alias))])])])
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 400 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "user-chats"
    }
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    attrs: {
      "id": "public-list"
    }
  }, _vm._l((_vm.PublicChats), function(publicChat) {
    return _c('a', {
      key: publicChat.id,
      class: {
        selected: _vm.chatId === 'public.' + publicChat.id
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.switchToChat('public.' + publicChat.id)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(publicChat.alias))]), _vm._v(" "), (publicChat.unreadMessages != 0) ? _c('span', {
      staticClass: "unread-message-count"
    }, [_vm._v(_vm._s(publicChat.unreadMessages))]) : _vm._e()])
  }), 0), _vm._v(" "), (_vm.addGroupMode) ? [_vm._m(1), _vm._v(" "), (_vm.addGroupMode) ? _c('section', {
    attrs: {
      "id": "new-group-form"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newGroupName),
      expression: "newGroupName"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Group Name...",
      "disabled": _vm.savingNewGroup
    },
    domProps: {
      "value": (_vm.newGroupName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newGroupName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "button-container"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.savingNewGroup
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addGroupMode = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.savingNewGroup
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createNewGroup($event)
      }
    }
  }, [_vm._v("Create")])])]) : _vm._e()] : _vm._e(), _vm._v(" "), (!_vm.addGroupMode) ? [_vm._m(2), _vm._v(" "), _c('section', {
    attrs: {
      "id": "groups-list"
    }
  }, [_c('span', {
    staticClass: "add-group-button"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addGroupMode = true
      }
    }
  }, [_vm._v("Create a New Group "), _c('i', {
    staticClass: "fa fa-plus-circle"
  })])]), _vm._v(" "), _vm._l((_vm.groupChats), function(groupChat) {
    return _c('a', {
      key: groupChat.id,
      class: {
        selected: _vm.chatId === 'group.' + groupChat.id
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.switchToChat('group.' + groupChat.id)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(groupChat.alias))]), _vm._v(" "), (groupChat.unreadMessages != 0) ? _c('span', {
      staticClass: "unread-message-count"
    }, [_vm._v(_vm._s(groupChat.unreadMessages))]) : _vm._e()])
  })], 2)] : _vm._e(), _vm._v(" "), (_vm.friendChats.length > 0) ? [_vm._m(3), _vm._v(" "), _c('section', {
    attrs: {
      "id": "friends-list"
    }
  }, _vm._l((_vm.friendChats), function(friendChat) {
    return _c('a', {
      key: friendChat.friendChatId,
      class: {
        selected: _vm.chatId === 'private.' + friendChat.friendChatId
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.switchToChat('private.' + friendChat.friendChatId)
        }
      }
    }, [_c('img', {
      staticClass: "avatar",
      attrs: {
        "src": _vm.generateAvatarImage(friendChat)
      }
    }), _vm._v(" "), (friendChat.isOnline) ? _c('i', {
      staticClass: "fa fa-circle online-status"
    }) : _vm._e(), _vm._v(" "), (friendChat.unreadMessages != 0) ? _c('span', {
      staticClass: "unread-message-count"
    }, [_vm._v(_vm._s(friendChat.unreadMessages))]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "friends-list-alias"
    }, [_vm._v(_vm._s(friendChat.alias))])])
  }), 0)] : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('i', {
    staticClass: "fa fa-fw fa-home"
  }), _vm._v(" Public Chats")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('i', {
    staticClass: "fa fa-fw fa-home"
  }), _vm._v(" Create a new Group")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('i', {
    staticClass: "fa fa-fw fa-group"
  }), _vm._v(" Group Chats")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('i', {
    staticClass: "fa fa-fw fa-user"
  }), _vm._v(" Friend Chats")])
}]}

/***/ }),
/* 401 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "id": "register-form"
    }
  }, [_c('h1', [_vm._v("Sign Up!")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.alias),
      expression: "alias"
    }],
    attrs: {
      "type": "text",
      "placeholder": "User Name...",
      "disabled": _vm.isSaving
    },
    domProps: {
      "value": (_vm.alias)
    },
    on: {
      "change": function($event) {
        _vm.errors = []
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.alias = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Email...",
      "disabled": _vm.isSaving
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "change": function($event) {
        _vm.errors = []
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "Password...",
      "disabled": _vm.isSaving
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "change": function($event) {
        _vm.errors = []
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwordVerify),
      expression: "passwordVerify"
    }],
    attrs: {
      "type": "password",
      "placeholder": "Verify Password...",
      "disabled": _vm.isSaving
    },
    domProps: {
      "value": (_vm.passwordVerify)
    },
    on: {
      "change": function($event) {
        _vm.errors = []
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.passwordVerify = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gender-switcher"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gender),
      expression: "gender"
    }],
    attrs: {
      "type": "radio",
      "id": "gender-male",
      "name": "gender",
      "value": "Male"
    },
    domProps: {
      "checked": _vm._q(_vm.gender, "Male")
    },
    on: {
      "change": function($event) {
        _vm.gender = "Male"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "gender-male"
    }
  }, [_vm._v("Male")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gender),
      expression: "gender"
    }],
    attrs: {
      "type": "radio",
      "id": "gender-female",
      "name": "gender",
      "value": "Female"
    },
    domProps: {
      "checked": _vm._q(_vm.gender, "Female")
    },
    on: {
      "change": function($event) {
        _vm.gender = "Female"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "gender-female"
    }
  }, [_vm._v("Female")])]), _vm._v(" "), _c('div', {
    staticClass: "agree-to-toc checkbox-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreesToToc),
      expression: "agreesToToc"
    }],
    attrs: {
      "type": "checkbox",
      "id": "agree-check",
      "disabled": _vm.isSaving
    },
    domProps: {
      "checked": Array.isArray(_vm.agreesToToc) ? _vm._i(_vm.agreesToToc, null) > -1 : (_vm.agreesToToc)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.agreesToToc,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.agreesToToc = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.agreesToToc = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.agreesToToc = $$c
        }
      }, function($event) {
        _vm.errors = []
      }]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "fake-checkbox",
    attrs: {
      "for": "agree-check"
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "agree-to-age checkbox-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreesToAge),
      expression: "agreesToAge"
    }],
    attrs: {
      "type": "checkbox",
      "id": "agree-age",
      "disabled": _vm.isSaving
    },
    domProps: {
      "checked": Array.isArray(_vm.agreesToAge) ? _vm._i(_vm.agreesToAge, null) > -1 : (_vm.agreesToAge)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.agreesToAge,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.agreesToAge = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.agreesToAge = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.agreesToAge = $$c
        }
      }, function($event) {
        _vm.errors = []
      }]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "fake-checkbox",
    attrs: {
      "for": "agree-age"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "checkbox-description",
    attrs: {
      "for": "agree-age"
    }
  }, [_vm._v("I am 13+ years old")])]), _vm._v(" "), (_vm.errors.length > 0) ? _c('div', {
    staticClass: "validation error"
  }, _vm._l((_vm.errors), function(error) {
    return _c('span', [_vm._v(_vm._s(error))])
  }), 0) : _vm._e(), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.isSaving
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }, [_vm._v("Register")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "checkbox-description",
    attrs: {
      "for": "agree-check"
    }
  }, [_vm._v("I agree with the\n            "), _c('a', {
    attrs: {
      "href": "/Doc/TOC",
      "target": "_blank"
    }
  }, [_vm._v("Terms & Conditions")]), _vm._v("\n            and\n            "), _c('a', {
    attrs: {
      "href": "/Doc/PrivacyPolicy",
      "target": "_blank"
    }
  }, [_vm._v("Privacy Policy")])])
}]}

/***/ }),
/* 402 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "login-form-container"
    }
  }, [_c('div', {
    attrs: {
      "id": "login-form-panel"
    }
  }, [_c('form', {
    attrs: {
      "id": "login-form"
    }
  }, [_c('h1', [_vm._v("Log in")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    ref: "emailField",
    attrs: {
      "type": "text",
      "placeholder": "Email..."
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "change": function($event) {
        _vm.errors = []
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "Password..."
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "change": function($event) {
        _vm.errors = []
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "remember-me checkbox-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rememberMe),
      expression: "rememberMe"
    }],
    attrs: {
      "type": "checkbox",
      "id": "remember-me-check"
    },
    domProps: {
      "checked": Array.isArray(_vm.rememberMe) ? _vm._i(_vm.rememberMe, null) > -1 : (_vm.rememberMe)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.rememberMe,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.rememberMe = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.rememberMe = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.rememberMe = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "fake-checkbox",
    attrs: {
      "for": "remember-me-check"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "checkbox-description",
    attrs: {
      "for": "remember-me-check"
    }
  }, [_vm._v("Remember Me")])]), _vm._v(" "), (_vm.errors.length > 0) ? _c('div', {
    staticClass: "validation error"
  }, _vm._l((_vm.errors), function(error) {
    return _c('span', [_vm._v(_vm._s(error))])
  }), 0) : _vm._e(), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }, [_vm._v("Log In")])])])])
},staticRenderFns: []}

/***/ }),
/* 403 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    class: [{
      'dark': _vm.isDarkMode
    }],
    attrs: {
      "id": "theme-selector"
    }
  }, [_c('h1', [_vm._v("Select a Theme!")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "available-themes"
    }
  }, _vm._l((_vm.availableThemes), function(theme) {
    return _c('div', {
      staticClass: "theme",
      class: [("theme-" + theme), {
        selected: theme == _vm.selectedTheme
      }],
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.selectTheme(theme)
        }
      }
    }, [_c('span', {
      staticClass: "regular-text"
    }, [_vm._v("A")]), _vm._v(" "), _c('span', {
      staticClass: "link"
    }, [_vm._v("A")])])
  }), 0), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleDarkMode($event)
      }
    }
  }, [_vm._v("Toggle Dark Mode")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePanel($event)
      }
    }
  }, [_vm._v("Close Theme Panel")])])
},staticRenderFns: []}

/***/ }),
/* 404 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "companion-ad-container"
    }
  }, [_c('adsense', {
    attrs: {
      "adtest": "on",
      "ad-client": "ca-pub-4242311851434474",
      "ad-slot": _vm.adSlot,
      "ad-style": "display: block",
      "ad-format": "auto"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 405 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showModal) ? _c('div', {
    attrs: {
      "id": "modal"
    }
  }, [_c('div', {
    staticClass: "wrapper",
    on: {
      "click": _vm.closeModal
    }
  }, [_c('div', {
    staticClass: "shield"
  }), _vm._v(" "), _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.modalContent)
    }
  })])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 406 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "logged-details"
    }
  }, [(!_vm.settingsMode) ? _c('h1', [_vm._v(_vm._s(_vm.loggedUser.alias))]) : _vm._e(), _vm._v(" "), (!_vm.settingsMode) ? _c('div', {
    staticClass: "primary-details"
  }, [_c('input', {
    staticClass: "input-file",
    attrs: {
      "type": "file",
      "name": "new-avatar",
      "id": "new-avatar"
    },
    on: {
      "change": _vm.uploadNewAvatar
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "avatar",
    attrs: {
      "for": "new-avatar"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.avatarImage
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('a', {
    attrs: {
      "href": ("/Profile/" + (_vm.loggedUser.stringUrl)),
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-user"
  }), _vm._v(" My Profile")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.settingsMode = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-cog"
  }), _vm._v(" Settings")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.logout($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-sign-out"
  }), _vm._v(" Logout")])])]) : _vm._e(), _vm._v(" "), (_vm.settingsMode) ? _c('div', {
    staticClass: "settings"
  }, [_c('h1', [_vm._v("Settings")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.useMetric),
      expression: "useMetric"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": _vm.savingSettings
    },
    domProps: {
      "checked": Array.isArray(_vm.useMetric) ? _vm._i(_vm.useMetric, null) > -1 : (_vm.useMetric)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.useMetric,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.useMetric = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.useMetric = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.useMetric = $$c
        }
      }
    }
  }), _vm._v(" Use Metric")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.useSwearFilter),
      expression: "useSwearFilter"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": _vm.savingSettings
    },
    domProps: {
      "checked": Array.isArray(_vm.useSwearFilter) ? _vm._i(_vm.useSwearFilter, null) > -1 : (_vm.useSwearFilter)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.useSwearFilter,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.useSwearFilter = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.useSwearFilter = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.useSwearFilter = $$c
        }
      }
    }
  }), _vm._v(" Filter Swear Words")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ignoreThreshold),
      expression: "ignoreThreshold"
    }],
    attrs: {
      "type": "number",
      "disabled": _vm.savingSettings
    },
    domProps: {
      "value": (_vm.ignoreThreshold)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ignoreThreshold = $event.target.value
      }
    }
  }), _vm._v(" Auto-ignore Threshold")]), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.savingSettings
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveSettings($event)
      }
    }
  }, [_vm._v("Save Settings")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "friend-requests"
  }, [(!_vm.showFriendRequests) ? [_c('a', {
    staticClass: "request-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showFriendRequests = true
      }
    }
  }, [(!_vm.retrievedPendingFriendRequests) ? _c('i', {
    staticClass: "fa fa-spin fa-circle-o-notch"
  }) : _vm._e(), _vm._v(" "), (_vm.retrievedPendingFriendRequests) ? _c('span', [_vm._v(_vm._s(_vm.pendingFriendRequests.length))]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("Friend Request")]), (_vm.pendingFriendRequests.length !== 1) ? _c('span', [_vm._v("s")]) : _vm._e()])] : _vm._e(), _vm._v(" "), (_vm.showFriendRequests) ? [_c('a', {
    staticClass: "return-from-friend-requests",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showFriendRequests = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-left"
  }), _vm._v(" Return")]), _vm._v(" "), (!_vm.retrievedPendingFriendRequests) ? _c('loader-large') : _vm._e(), _vm._v(" "), (_vm.retrievedPendingFriendRequests) ? [(_vm.pendingFriendRequests.length === 0) ? _c('div', {
    staticClass: "no-pending-requests"
  }, [_vm._v("You have no pending friend requests")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.pendingFriendRequests), function(pendingFriendRequest) {
    return _c('div', {
      staticClass: "pending-friend-request"
    }, [_c('a', {
      attrs: {
        "href": ("/Profile/" + (pendingFriendRequest.senderStringUrl)),
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.generateFriendRequestAvatar(pendingFriendRequest)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "friend-request-details"
    }, [_c('a', {
      attrs: {
        "href": ("/Profile/" + (pendingFriendRequest.senderStringUrl)),
        "target": "_blank"
      }
    }, [_vm._v("\n                            " + _vm._s(pendingFriendRequest.senderAlias) + "\n                        ")]), _vm._v(" "), _c('div', {
      staticClass: "button-container"
    }, [_c('button', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.acceptFriendRequest(pendingFriendRequest)
        }
      }
    }, [_vm._v("Accept")]), _vm._v(" "), _c('button', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.declineFriendRequest(pendingFriendRequest)
        }
      }
    }, [_vm._v("Decline")])])])])
  })] : _vm._e()] : _vm._e()], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upload-overlay"
  }, [_c('i', {
    staticClass: "fa fa-upload"
  })])
}]}

/***/ }),
/* 407 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('home-page')
},staticRenderFns: []}

/***/ }),
/* 408 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading large"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" "), _c('p', [_vm._v("Loading")])])
}]}

/***/ }),
/* 409 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ins', {
    staticClass: "adsbygoogle",
    style: (_vm.adStyle),
    attrs: {
      "data-google-adtest": "on",
      "data-ad-client": _vm.adClient,
      "data-ad-slot": _vm.adSlot,
      "data-ad-format": _vm.adFormat
    }
  })
},staticRenderFns: []}

/***/ }),
/* 410 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Terms and Conditions")]), _vm._v(" "), _c('h1', [_vm._v("Introduction")]), _vm._v(" "), _c('p', [_vm._v("These Website Standard Terms and Conditions written on this webpage shall manage your use of this website. These Terms will be applied fully and affect to your use of this Website. By using this Website, you agreed to accept all terms and conditions written in here. You must not use this Website if you disagree with any of these Website Standard Terms and Conditions.")]), _vm._v(" "), _c('p', [_vm._v("Minors or people below 13 years old are not allowed to use this Website.")]), _vm._v(" "), _c('h1', [_vm._v("Intellectual Property Rights")]), _vm._v(" "), _c('p', [_vm._v("Other than the content you own, under these Terms, Mixsii and/or its licensors own all the intellectual property rights and materials contained in this Website.")]), _vm._v(" "), _c('p', [_vm._v("You are granted limited license only for purposes of viewing the material contained on this Website.")]), _vm._v(" "), _c('h1', [_vm._v("Restrictions")]), _vm._v(" "), _c('p', [_vm._v("You are specifically restricted from all of the following")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("publishing any Website material in any other media;")]), _vm._v(" "), _c('li', [_vm._v("selling, sublicensing and/or otherwise commercializing any Website material;")]), _vm._v(" "), _c('li', [_vm._v("publicly performing and/or showing any Website material;")]), _vm._v(" "), _c('li', [_vm._v("using this Website in any way that is or may be damaging to this Website;")]), _vm._v(" "), _c('li', [_vm._v("using this Website in any way that impacts user access to this Website;")]), _vm._v(" "), _c('li', [_vm._v("using this Website contrary to applicable laws and regulations, or in any way may cause harm to the Website, or to any person or business entity;")]), _vm._v(" "), _c('li', [_vm._v("engaging in any data mining, data harvesting, data extracting or any other similar activity in relation to this Website;")]), _vm._v(" "), _c('li', [_vm._v("using this Website to engage in any advertising or marketing.")])]), _vm._v(" "), _c('p', [_vm._v("Certain areas of this Website are restricted from being access by you and Mixsii may further restrict access by you to any areas of this Website, at any time, in absolute discretion. Any user ID and password you may have for this Website are confidential and you must maintain confidentiality as well.")]), _vm._v(" "), _c('h1', [_vm._v("Your Content")]), _vm._v(" "), _c('p', [_vm._v("In these Website Standard Terms and Conditions, “Your Content” shall mean any audio, video text, images or other material you choose to display on this Website. By displaying Your Content, you grant Mixsii a non-exclusive, worldwide irrevocable, sub licensable license to use, reproduce, adapt, publish, translate and distribute it in any and all media.")]), _vm._v(" "), _c('p', [_vm._v("Your Content must be your own and must not be invading any third-party’s rights. Mixsii reserves the right to remove any of Your Content from this Website at any time without notice.")]), _vm._v(" "), _c('h1', [_vm._v("No warranties")]), _vm._v(" "), _c('p', [_vm._v("This Website is provided “as is,” with all faults, and Mixsii express no representations or warranties, of any kind related to this Website or the materials contained on this Website. Also, nothing contained on this Website shall be interpreted as advising you.")]), _vm._v(" "), _c('h1', [_vm._v("Limitation of liability")]), _vm._v(" "), _c('p', [_vm._v("In no event shall Mixsii, nor any of its officers, directors and employees, shall be held liable for anything arising out of or in any way connected with your use of this Website whether such liability is under contract.  Mixsii, including its officers, directors and employees shall not be held liable for any indirect, consequential or special liability arising out of or in any way related to your use of this Website.")]), _vm._v(" "), _c('h1', [_vm._v("Indemnification")]), _vm._v(" "), _c('p', [_vm._v("You hereby indemnify to the fullest extent Mixsii from and against any and/or all liabilities, costs, demands, causes of action, damages and expenses arising in any way related to your breach of any of the provisions of these Terms.")]), _vm._v(" "), _c('h1', [_vm._v("Severability")]), _vm._v(" "), _c('p', [_vm._v("If any provision of these Terms is found to be invalid under any applicable law, such provisions shall be deleted without affecting the remaining provisions herein.")]), _vm._v(" "), _c('h1', [_vm._v("Variation of Terms")]), _vm._v(" "), _c('p', [_vm._v("Mixsii is permitted to revise these Terms at any time as it sees fit, and by using this Website you are expected to review these Terms on a regular basis.")]), _vm._v(" "), _c('h1', [_vm._v("Assignment")]), _vm._v(" "), _c('p', [_vm._v("The Mixsii is allowed to assign, transfer, and subcontract its rights and/or obligations under these Terms without any notification. However, you are not allowed to assign, transfer, or subcontract any of your rights and/or obligations under these Terms.")]), _vm._v(" "), _c('h1', [_vm._v("Entire Agreement")]), _vm._v(" "), _c('p', [_vm._v("These Terms constitute the entire agreement between Mixsii and you in relation to your use of this Website, and supersede all prior agreements and understandings.")]), _vm._v(" "), _c('h1', [_vm._v("Governing Law & Jurisdiction")]), _vm._v(" "), _c('p', [_vm._v("These Terms will be governed by and interpreted in accordance with the laws of the State of Washington, and you submit to the non-exclusive jurisdiction of the state and federal courts located in Washington for the resolution of any disputes.")])])
}]}

/***/ }),
/* 411 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    class: ['theme-' + _vm.selectedTheme, {
      'rolled-out': _vm.isRolledOut
    }],
    attrs: {
      "id": "active-chats-panel"
    }
  }, [_c('div', [(_vm.activeChatType === 'group') ? _c('group-details') : _vm._e(), _vm._v(" "), _c('user-chats')], 1)])
},staticRenderFns: []}

/***/ }),
/* 412 */,
/* 413 */,
/* 414 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 415 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
]),[184]);


// WEBPACK FOOTER //
// src/js/app.19ea97dcf879f2edd4d2.js